// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/autotractor.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Polygon2D } from "../geometry/geometry";
import { Duration } from "../google/protobuf/duration";
import { Empty } from "../google/protobuf/empty";
import { Timestamp } from "../google/protobuf/timestamp";
import { RigActivitiesConfiguration } from "./activities";
import { ImplementBoundaryModel, TractorBoundaryModel } from "./boundary_model";
import { ImplementCalibration, TractorCalibration } from "./calibration";
import {
  AtimInterface,
  atimInterfaceFromJSON,
  atimInterfaceToJSON,
  AutonomousActivityType,
  autonomousActivityTypeFromJSON,
  autonomousActivityTypeToJSON,
  ControlScheme,
  controlSchemeFromJSON,
  controlSchemeToJSON,
  DataModelVersion,
  dataModelVersionFromJSON,
  dataModelVersionToJSON,
  DriveType,
  driveTypeFromJSON,
  driveTypeToJSON,
  HitchType,
  hitchTypeFromJSON,
  hitchTypeToJSON,
  HydraulicCouplerType,
  hydraulicCouplerTypeFromJSON,
  hydraulicCouplerTypeToJSON,
  PtoSpeed,
  ptoSpeedFromJSON,
  ptoSpeedToJSON,
  PtoType,
  ptoTypeFromJSON,
  ptoTypeToJSON,
  ScvAutonomyAuxControlAction,
  scvAutonomyAuxControlActionFromJSON,
  scvAutonomyAuxControlActionToJSON,
  TurnDirection,
  turnDirectionFromJSON,
  turnDirectionToJSON,
} from "./enums";
import { JobType, jobTypeFromJSON, jobTypeToJSON } from "./job_type";

export const protobufPackage = "carbon.atk";

/**
 * Autotractor represents the remote-control and autonomy system made by Carbon
 * Robotics. The Autotractor system incorporates functionality from an entire
 * tractor-implement operation unit,
 *  so an Autotractor includes the Tractor on which it is mounted as well as
 *  connected implements.
 */
export interface Autotractor {
  id: string;
  /** @deprecated */
  customerId: string;
  customerUuid: string;
  dataModelVersion: DataModelVersion;
  captureCompleted: boolean;
  updatedAt?: string | undefined;
  customerProvidedName: string;
  serial: string;
  settings: AutotractorSettings | undefined;
  tractor?: Tractor | undefined;
  implements: Implement[];
  controls: ImplementControlSchema | undefined;
  scvConnections: ScvConnections | undefined;
  jobSettings?: JobSettings | undefined;
}

export interface JobSettings {
  jobType: JobType;
  checklistDefinitionId: number;
  checklistTimeoutS: Duration | undefined;
}

export interface ScvConnections {
  connections: ScvConnection[];
}

/**
 * TractorArchetype represents a class of tractor that the Autotractor system
 * supports. It will include all the default values for a tractor of that type.
 * Things like make and model cannot be overriden, but the width, scvs, and
 * wheel spacing can.
 */
export interface TractorArchetype {
  id: string;
  dataModelVersion: DataModelVersion;
  updatedAt?: string | undefined;
  make: string;
  model: string;
  series?: string | undefined;
  scvOutputs: ScvOutputs | undefined;
  frontPto?: PtoConfig | undefined;
  rearPto?: PtoConfig | undefined;
  steeringRange:
    | SteeringRange
    | undefined;
  /** @deprecated */
  minTurningRadiusM: number;
  wheelSpacingM: number;
  wheelbaseM: number;
  driveType: DriveType;
  /** the boundary of the tractor, relative to the center of the front axle. */
  boundary:
    | Polygon2D
    | undefined;
  /**
   * the underlying geometric data which was captured by the user to generate
   * the boundary polygon.  should be ignored by the robot; the frontends take
   * responsibility for generating .boundary from .boundary_model.
   */
  boundaryModel?: TractorBoundaryModel | undefined;
  hitches: TractorHitches | undefined;
  calibration?: TractorCalibration | undefined;
}

/**
 * Tractor represents a specific instance of a TractorArchetype. All fields
 * marked optional are overrides. If any of the fields are specified, those
 * fields should be used instead of what is on the archetype.
 *
 * Overrides will mostly include information which may vary between tractors of
 * the same model, like farm-specific modifications and restrictions.
 */
export interface Tractor {
  id: string;
  /** @deprecated */
  customerId: string;
  customerUuid: string;
  dataModelVersion: DataModelVersion;
  /**
   * this flag is set to true by the end of the frontend process that captures
   * the data for a customer's tractor.  this allows us to identify which data
   * models have not been fully completed.
   */
  captureCompleted: boolean;
  updatedAt?: string | undefined;
  name: string;
  archetype: TractorArchetype | undefined;
  scvOutputs?: ScvOutputs | undefined;
  frontPto?: PtoConfig | undefined;
  rearPto?: PtoConfig | undefined;
  steeringRange?:
    | SteeringRange
    | undefined;
  /** @deprecated */
  minTurningRadiusM?: number | undefined;
  wheelSpacingM?:
    | number
    | undefined;
  /** the boundary of the tractor, relative to the center of the front axle. */
  boundary?:
    | Polygon2D
    | undefined;
  /**
   * the underlying geometric data which was captured by the user to generate
   * the boundary polygon.  should be ignored by the robot; the frontends take
   * responsibility for generating .boundary from .boundary_model.
   */
  boundaryModel?: TractorBoundaryModel | undefined;
  hitches?: TractorHitches | undefined;
  calibration?: TractorCalibration | undefined;
}

export interface TractorHitches {
  hitches: TractorHitch[];
}

/** Steering range as min/max values */
export interface SteeringRange {
  min: number;
  max: number;
}

export interface PtoRequirements {
  type: PtoType;
  engineSpeedRpm: number;
  /** no units because pto_speed values don't map 1:1 with rotation speed */
  ptoSpeed: PtoSpeed;
}

/**
 * the safe turning radius for ground prep implements increases as the
 * implement engages more with the ground.
 *
 * @deprecated
 */
export interface ImplementHeightTurningRadiusLimit {
  /**
   * the maximum implement height (0-100) at which this turning radius limit
   * applies.
   */
  maxHeight: number;
  /**
   * the minimum safe turning radius for the implement (in meters) at heights
   * below max_height.
   */
  minTurningRadiusM: number;
}

export interface ImplementSensors {
  ioLinkSensors: IOLinkRegisterDevice[];
}

/**
 * ImplementArchetype represents a class of farm equipment which is typically
 * hauled behind a Tractor.
 */
export interface ImplementArchetype {
  id: string;
  dataModelVersion: DataModelVersion;
  updatedAt?: string | undefined;
  make: string;
  model: string;
  series?: string | undefined;
  hitchType: HitchType;
  ptoRequirements: PtoRequirements | undefined;
  scvInputs: ScvInputs | undefined;
  atim?:
    | AtimInterface
    | undefined;
  /**
   * working_width_m is deprecated in favor of working_width_m_left/right
   * because it does not account for implements which are not symmetrical about
   * the hitch point.
   *
   * @deprecated
   */
  workingWidthM: number;
  /**
   * working_width_m_left is the width of the implement's worked swath left of
   * the hitch point.
   */
  workingWidthMLeft?:
    | number
    | undefined;
  /**
   * working_width_m_right is the width of the implement's worked swath right of
   * the hitch point.
   */
  workingWidthMRight?:
    | number
    | undefined;
  /**
   * working_start_offset_m is the distance between the hitch point and the
   * front plane of the working area of the implement
   */
  workingStartOffsetM: number;
  /**
   * working_end_offset_m is the distance between the hitch point and the end
   * plane of the working area of the implement
   */
  workingEndOffsetM: number;
  /**
   * turn_direction is the only direction the implement can turn while
   * lowered; unset when it can turn either way.
   */
  turnDirection?:
    | TurnDirection
    | undefined;
  /**
   * these fields are deprecated in favor of the rig activity configuration in
   * M6.
   *
   * @deprecated
   */
  toolSpeedMS: number;
  /** @deprecated */
  transitionSpeedMS: number;
  /** @deprecated */
  runUpDistanceM: number;
  /** @deprecated */
  straightenDistanceM: number;
  /** @deprecated */
  turningRadiusLimits: ImplementHeightTurningRadiusLimit[];
  /**
   * the boundary of the implement, relative to the hitch point on
   * the tractor that pulls it.
   */
  boundary:
    | Polygon2D
    | undefined;
  /**
   * the underlying geometric data which was captured by the user to generate
   * the boundary polygon.  should be ignored by the robot; the frontends take
   * responsibility for generating .boundary from .boundary_model.
   */
  boundaryModel?: ImplementBoundaryModel | undefined;
  calibration?:
    | ImplementCalibration
    | undefined;
  /** @deprecated */
  sensors?: ImplementSensors | undefined;
}

/**
 * Implement represents a specific instance of an ImplementArchetype. Most
 * fields here are overrides for the linked ImplementArchetype.
 */
export interface Implement {
  id: string;
  /** @deprecated */
  customerId: string;
  customerUuid: string;
  dataModelVersion: DataModelVersion;
  /**
   * this flag is set to true by the end of the frontend process that captures
   * the data for a customer's implement.  this allows us to identify which data
   * models have not been fully completed.
   */
  captureCompleted: boolean;
  updatedAt?: string | undefined;
  name: string;
  archetype?: ImplementArchetype | undefined;
  hitchType?: HitchType | undefined;
  ptoRequirements?: PtoRequirements | undefined;
  scvInputs?: ScvInputs | undefined;
  atim?:
    | AtimInterface
    | undefined;
  /**
   * working_width_m is deprecated in favor of working_width_m_left/right
   * because it does not account for implements which are not symmetrical about
   * the hitch point.
   *
   * @deprecated
   */
  workingWidthM?:
    | number
    | undefined;
  /**
   * working_width_m_left is the width of the implement's worked swath left of
   * the hitch point.
   */
  workingWidthMLeft?:
    | number
    | undefined;
  /**
   * working_width_m_right is the width of the implement's worked swath right of
   * the hitch point.
   */
  workingWidthMRight?:
    | number
    | undefined;
  /**
   * working_start_offset_m is the distance between the hitch point and the
   * front plane of the working area of the implement
   */
  workingStartOffsetM?:
    | number
    | undefined;
  /**
   * working_end_offset_m is the distance between the hitch point and the end
   * plane of the working area of the implement
   */
  workingEndOffsetM?:
    | number
    | undefined;
  /**
   * turn_direction is the only direction the implement can turn while
   * lowered; unset when it can turn either way.
   */
  turnDirection?:
    | TurnDirection
    | undefined;
  /**
   * these fields are deprecated in favor of the rig activity configuration in
   * M6.
   *
   * @deprecated
   */
  toolSpeedMS?:
    | number
    | undefined;
  /** @deprecated */
  transitionSpeedMS?:
    | number
    | undefined;
  /** @deprecated */
  runUpDistanceM?:
    | number
    | undefined;
  /** @deprecated */
  straightenDistanceM?:
    | number
    | undefined;
  /** @deprecated */
  turningRadiusLimits: ImplementHeightTurningRadiusLimit[];
  /**
   * the boundary of the implement, relative to the hitch point on
   * the tractor that pulls it.
   */
  boundary?:
    | Polygon2D
    | undefined;
  /**
   * the underlying geometric data which was captured by the user to generate
   * the boundary polygon.  should be ignored by the robot; the frontends take
   * responsibility for generating .boundary from .boundary_model.
   */
  boundaryModel?: ImplementBoundaryModel | undefined;
  calibration?:
    | ImplementCalibration
    | undefined;
  /** @deprecated */
  sensors?: ImplementSensors | undefined;
}

/** Mapping between tractor(output)=>implement(input) scv */
export interface ScvConnection {
  id: string;
  tractorScvOutputId: string;
  implementScvInputId: string;
}

export interface ScvInputs {
  inputs: ScvInput[];
}

/** An SCV input to an implement. */
export interface ScvInput {
  id: string;
  /** e.g. Lift/Lower Plow Blade */
  function: string;
  /** plug this into tractor port X */
  recommendedPort: string;
  /**
   * deprecated user-facing hint about mechanical compatibility for SCV output
   *
   * @deprecated
   */
  couplerDiameterMm: number;
  /**
   * user-facing hint about mechanical compatibility for SCV input, to avoid
   * mistakes like connecting an input and an output which would require a hose
   * adapter.
   */
  coupler: HydraulicCouplerType;
  /**
   * true if the SCV input is a hydraulic top link for a three-point hitch.
   * this affects the way the new-action menus are laid out in the front end UI.
   */
  isHydraulicTopLink: boolean;
}

export interface ScvOutputs {
  scvOutput: ScvOutput[];
}

/** An SCV output from a tractor. */
export interface ScvOutput {
  id: string;
  /** I, II, III, IV etc */
  port: number;
  /** blue rear port? */
  description: string;
  /**
   * deprecated user-facing hint about mechanical compatibility for SCV output
   *
   * @deprecated
   */
  couplerDiameterMm: number;
  /**
   * user-facing hint about mechanical compatibility for SCV output, to avoid
   * mistakes like connecting an input and an output which would require a hose
   * adapter.
   */
  coupler: HydraulicCouplerType;
  /** if this port is available on the tractor but should not be used */
  disabled: boolean;
}

export interface TractorHitch {
  type: HitchType;
  /** relative to tractor origin */
  offsetYM: number;
}

/** PTO configuration */
export interface PtoConfig {
  disabled: boolean;
  availableSpeeds: PtoSpeed[];
}

/** Autotractor-specific settings */
export interface AutotractorSettings {
  /**
   * by default the ATK chooses whether to use the wheeled or tracked steering
   * model based on the tractor's drive type; when this system was created we
   * added an override for it per-kit, but that override was never wired up, it
   * can only be set by Carbon employees, and we haven't missed its absence, so
   * it's deprecated now.  to be removed in M7
   *
   * @deprecated
   */
  controlSchemeOverride?: ControlScheme | undefined;
  maxSpeedMph: number;
  maxSpeedSafetyBypassedMph: number;
  /**
   * deprecated because this can't be set on Ops Center, the flag was never
   * respected by the robot, and HW2.x and HW3 don't support differential
   * braking at a hardware level; to be removed in M7
   *
   * @deprecated
   */
  differentialBrakingEnabled: boolean;
  /**
   * this field was added in the initial proto design but is not used in prod
   * code: steering angle is difficult to measure for operators and the safe
   * steering angle varies with the depth of implement engagement
   *
   * @deprecated
   */
  maxSteeringAngleImplementEngaged: number;
  hitchDownVal: number;
}

export interface Sensor {
  /** which sensor port the sensor is plugged into on our kit */
  port: number;
  pctConversion:
    | LinearPctConversion
    | undefined;
  /** what scv this sensor 'measures the position of' */
  scvConnectionId?: string | undefined;
}

export interface SensorConfig {
  sensors: Sensor[];
}

export interface ImplementControlSchema {
  liftLowerControls:
    | LiftLowerControls
    | undefined;
  /** @deprecated */
  ioConfig?:
    | ImplementIOConfiguration
    | undefined;
  /** @deprecated */
  ioLinkCfg?: IOLinkConfig | undefined;
  sensors?:
    | SensorConfig
    | undefined;
  /**
   * superseded by the activity/actuation model in atk/activities.proto
   *
   * @deprecated
   */
  scvAutonomy: ScvAutonomyConfiguration | undefined;
  activities: RigActivitiesConfiguration | undefined;
}

export interface LiftLowerControls {
  /** Max time it should take to lift */
  maxLiftTimeMs: number;
  /** Max time it should take to lower */
  maxLowerTimeMs: number;
  none?:
    | Empty
    | undefined;
  /** @deprecated */
  threePoint?: ThreePointControls | undefined;
}

export interface ImplementIOConfiguration {
  relayConfig: RelayConfiguration | undefined;
  inputConfig: InputPinConfiguration | undefined;
}

/** @deprecated */
export interface ThreePointControls {
  /**
   * Min value at which the 3pt is considered raised
   *
   * @deprecated
   */
  minRaisedValue: number;
  /**
   * Max value at which the 3pt is considered lowered
   *
   * @deprecated
   */
  maxLoweredValue: number;
  /**
   * implements like the LaserWeeder can optionally have an SCV-powered toplink.
   * this is implemented with a discrete hydraulic cylinder connected between
   * the tractor and implement; there is (as of 1/12/2026) no SCV entity
   * associated with it besides an SCV output.
   * change in M6: the toplink is now implemented as an SCV connection like any
   * other, owing to the change in the action configuration model.
   *
   * @deprecated
   */
  toplinkScvOutputId?: string | undefined;
}

export interface RelayConfiguration {
  hwV2Cfg?: HWV2RelayConfiguration | undefined;
}

export interface HWV2RelayConfiguration {
  estopConnected: boolean;
  momentaryEnableConnected: boolean;
  momentaryDisableConnected: boolean;
}

export interface InputPinConfiguration {
  hwV2Cfg?: HWV2InputPinConfiguration | undefined;
}

export interface HWV2InputPinConfiguration {
}

export interface IOLinkConfig {
  /** IP address of the IO-Link master; usually "10.12.18.1". */
  ipAddress: string;
  /** TCP port used for Modbus communications; usually 502. */
  modbusPort: number;
  /** @deprecated */
  readRegisters: IOLinkRegisterDevice[];
}

export interface IOLinkRegisterDevice {
  /** @deprecated */
  name: string;
  /** UUID */
  id: string;
  address: number;
  deviceId: number;
  conversion?:
    | DataTypeConversion
    | undefined;
  /** @deprecated */
  scvPosition?: IOLinkScvPositionSensor | undefined;
  scvInputPosition?: IOLinkScvInputPositionSensor | undefined;
  generic?: IOLinkGenericSensor | undefined;
}

export interface DataTypeConversion {
  linearPctConversion?: LinearPctConversion | undefined;
}

export interface LinearPctConversion {
  valAt0Pct: number;
  valAt100Pct: number;
}

export interface IOLinkScvPositionSensor {
  scvConnectionId: string;
}

export interface IOLinkScvInputPositionSensor {
  scvInputId: string;
}

export interface IOLinkGenericSensor {
  name: string;
}

/** @deprecated */
export interface ThreePointAutonomyControlConfiguration {
  /**
   * in this activity, ATK should actively hold the hitch at this position, as
   * a fraction of full
   */
  holdTargetHeight?:
    | number
    | undefined;
  /** in this activity, ATK should put the hitch in float mode */
  holdFloat?:
    | Empty
    | undefined;
  /** in this activity, ATK should not issue hitch commands */
  holdNone?:
    | Empty
    | undefined;
  /**
   * when entering this activity, ATK should move the hitch to this position,
   * as a fraction of full
   */
  entryGoToTargetHeight?:
    | number
    | undefined;
  /** when entering this activity, ATK should command detent up */
  entryDetentUp?:
    | Empty
    | undefined;
  /** when entering this activity, ATK should command detent down */
  entryDetentDown?:
    | Empty
    | undefined;
  /** when entering this activity, ATK should not command any hitch movement */
  entryNone?: Empty | undefined;
}

/** @deprecated */
export interface ScvAutonomyConfiguration {
  heightScvConnectionId?: string | undefined;
  aux1ScvConnectionId?: string | undefined;
  aux2ScvConnectionId?: string | undefined;
  activities: ScvAutonomyActivitiesConfiguration | undefined;
}

/** @deprecated */
export interface ScvAutonomyActivitiesConfiguration {
  activities: ScvAutonomyActivityConfiguration[];
}

/** @deprecated */
export interface ScvAutonomyActivityConfiguration {
  activityType: AutonomousActivityType;
  heightControl: ScvAutonomyHeightControlConfiguration | undefined;
  aux1Control: ScvAutonomyAuxControlConfiguration | undefined;
  aux2Control: ScvAutonomyAuxControlConfiguration | undefined;
  frontThreePtControl: ThreePointAutonomyControlConfiguration | undefined;
  rearThreePtControl:
    | ThreePointAutonomyControlConfiguration
    | undefined;
  /** How fast we must be travelling before we can transition */
  minTransitionVelocityMps: number;
  /** How long we wait to reach min vel before alarming if not reached */
  maxTransitionWaitS: number;
}

/** @deprecated */
export interface ScvAutonomyHeightControlConfiguration {
  /**
   * in this activity, ATK should target the given height, as a fraction of
   * full travel, on this SCV
   */
  holdTargetHeight?:
    | number
    | undefined;
  /** in this activity, ATK should command this SCV to off */
  scvOff?:
    | Empty
    | undefined;
  /** in this activity, ATK should not attempt to control this SCV */
  none?: Empty | undefined;
}

/** @deprecated */
export interface ScvAutonomyAuxControlConfiguration {
  entryAction: ScvAutonomyAuxControlAction;
}

/**
 * AutonomyAuthorized determines if carbon robotics systems has control of an
 * autotractor if this flag is false, we should not attempt to command an
 * autotractor.
 */
export interface AutonomyAuthorized {
  authorized: boolean;
  lockingUserIds: string[];
}

function createBaseAutotractor(): Autotractor {
  return {
    id: "",
    customerId: "",
    customerUuid: "",
    dataModelVersion: 0,
    captureCompleted: false,
    updatedAt: undefined,
    customerProvidedName: "",
    serial: "",
    settings: undefined,
    tractor: undefined,
    implements: [],
    controls: undefined,
    scvConnections: undefined,
    jobSettings: undefined,
  };
}

export const Autotractor: MessageFns<Autotractor> = {
  encode(message: Autotractor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(58).string(message.id);
    }
    if (message.customerId !== "") {
      writer.uint32(26).string(message.customerId);
    }
    if (message.customerUuid !== "") {
      writer.uint32(106).string(message.customerUuid);
    }
    if (message.dataModelVersion !== 0) {
      writer.uint32(96).int32(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      writer.uint32(112).bool(message.captureCompleted);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(74).fork()).join();
    }
    if (message.customerProvidedName !== "") {
      writer.uint32(82).string(message.customerProvidedName);
    }
    if (message.serial !== "") {
      writer.uint32(10).string(message.serial);
    }
    if (message.settings !== undefined) {
      AutotractorSettings.encode(message.settings, writer.uint32(18).fork()).join();
    }
    if (message.tractor !== undefined) {
      Tractor.encode(message.tractor, writer.uint32(34).fork()).join();
    }
    for (const v of message.implements) {
      Implement.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.controls !== undefined) {
      ImplementControlSchema.encode(message.controls, writer.uint32(50).fork()).join();
    }
    if (message.scvConnections !== undefined) {
      ScvConnections.encode(message.scvConnections, writer.uint32(66).fork()).join();
    }
    if (message.jobSettings !== undefined) {
      JobSettings.encode(message.jobSettings, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Autotractor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutotractor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.customerUuid = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.dataModelVersion = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.captureCompleted = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.customerProvidedName = reader.string();
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.settings = AutotractorSettings.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tractor = Tractor.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.implements.push(Implement.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.controls = ImplementControlSchema.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.scvConnections = ScvConnections.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.jobSettings = JobSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Autotractor {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      customerUuid: isSet(object.customerUuid)
        ? globalThis.String(object.customerUuid)
        : isSet(object.customer_uuid)
        ? globalThis.String(object.customer_uuid)
        : "",
      dataModelVersion: isSet(object.dataModelVersion)
        ? dataModelVersionFromJSON(object.dataModelVersion)
        : isSet(object.data_model_version)
        ? dataModelVersionFromJSON(object.data_model_version)
        : 0,
      captureCompleted: isSet(object.captureCompleted)
        ? globalThis.Boolean(object.captureCompleted)
        : isSet(object.capture_completed)
        ? globalThis.Boolean(object.capture_completed)
        : false,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      customerProvidedName: isSet(object.customerProvidedName)
        ? globalThis.String(object.customerProvidedName)
        : isSet(object.customer_provided_name)
        ? globalThis.String(object.customer_provided_name)
        : "",
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      settings: isSet(object.settings) ? AutotractorSettings.fromJSON(object.settings) : undefined,
      tractor: isSet(object.tractor) ? Tractor.fromJSON(object.tractor) : undefined,
      implements: globalThis.Array.isArray(object?.implements)
        ? object.implements.map((e: any) => Implement.fromJSON(e))
        : [],
      controls: isSet(object.controls) ? ImplementControlSchema.fromJSON(object.controls) : undefined,
      scvConnections: isSet(object.scvConnections)
        ? ScvConnections.fromJSON(object.scvConnections)
        : isSet(object.scv_connections)
        ? ScvConnections.fromJSON(object.scv_connections)
        : undefined,
      jobSettings: isSet(object.jobSettings)
        ? JobSettings.fromJSON(object.jobSettings)
        : isSet(object.job_settings)
        ? JobSettings.fromJSON(object.job_settings)
        : undefined,
    };
  },

  toJSON(message: Autotractor): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.customerUuid !== "") {
      obj.customerUuid = message.customerUuid;
    }
    if (message.dataModelVersion !== 0) {
      obj.dataModelVersion = dataModelVersionToJSON(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      obj.captureCompleted = message.captureCompleted;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.customerProvidedName !== "") {
      obj.customerProvidedName = message.customerProvidedName;
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.settings !== undefined) {
      obj.settings = AutotractorSettings.toJSON(message.settings);
    }
    if (message.tractor !== undefined) {
      obj.tractor = Tractor.toJSON(message.tractor);
    }
    if (message.implements?.length) {
      obj.implements = message.implements.map((e) => Implement.toJSON(e));
    }
    if (message.controls !== undefined) {
      obj.controls = ImplementControlSchema.toJSON(message.controls);
    }
    if (message.scvConnections !== undefined) {
      obj.scvConnections = ScvConnections.toJSON(message.scvConnections);
    }
    if (message.jobSettings !== undefined) {
      obj.jobSettings = JobSettings.toJSON(message.jobSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Autotractor>, I>>(base?: I): Autotractor {
    return Autotractor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Autotractor>, I>>(object: I): Autotractor {
    const message = createBaseAutotractor();
    message.id = object.id ?? "";
    message.customerId = object.customerId ?? "";
    message.customerUuid = object.customerUuid ?? "";
    message.dataModelVersion = object.dataModelVersion ?? 0;
    message.captureCompleted = object.captureCompleted ?? false;
    message.updatedAt = object.updatedAt ?? undefined;
    message.customerProvidedName = object.customerProvidedName ?? "";
    message.serial = object.serial ?? "";
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? AutotractorSettings.fromPartial(object.settings)
      : undefined;
    message.tractor = (object.tractor !== undefined && object.tractor !== null)
      ? Tractor.fromPartial(object.tractor)
      : undefined;
    message.implements = object.implements?.map((e) => Implement.fromPartial(e)) || [];
    message.controls = (object.controls !== undefined && object.controls !== null)
      ? ImplementControlSchema.fromPartial(object.controls)
      : undefined;
    message.scvConnections = (object.scvConnections !== undefined && object.scvConnections !== null)
      ? ScvConnections.fromPartial(object.scvConnections)
      : undefined;
    message.jobSettings = (object.jobSettings !== undefined && object.jobSettings !== null)
      ? JobSettings.fromPartial(object.jobSettings)
      : undefined;
    return message;
  },
};

function createBaseJobSettings(): JobSettings {
  return { jobType: 0, checklistDefinitionId: 0, checklistTimeoutS: undefined };
}

export const JobSettings: MessageFns<JobSettings> = {
  encode(message: JobSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobType !== 0) {
      writer.uint32(8).int32(message.jobType);
    }
    if (message.checklistDefinitionId !== 0) {
      writer.uint32(16).uint64(message.checklistDefinitionId);
    }
    if (message.checklistTimeoutS !== undefined) {
      Duration.encode(message.checklistTimeoutS, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.checklistDefinitionId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.checklistTimeoutS = Duration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobSettings {
    return {
      jobType: isSet(object.jobType)
        ? jobTypeFromJSON(object.jobType)
        : isSet(object.job_type)
        ? jobTypeFromJSON(object.job_type)
        : 0,
      checklistDefinitionId: isSet(object.checklistDefinitionId)
        ? globalThis.Number(object.checklistDefinitionId)
        : isSet(object.checklist_definition_id)
        ? globalThis.Number(object.checklist_definition_id)
        : 0,
      checklistTimeoutS: isSet(object.checklistTimeoutS)
        ? Duration.fromJSON(object.checklistTimeoutS)
        : isSet(object.checklist_timeout_s)
        ? Duration.fromJSON(object.checklist_timeout_s)
        : undefined,
    };
  },

  toJSON(message: JobSettings): unknown {
    const obj: any = {};
    if (message.jobType !== 0) {
      obj.jobType = jobTypeToJSON(message.jobType);
    }
    if (message.checklistDefinitionId !== 0) {
      obj.checklistDefinitionId = Math.round(message.checklistDefinitionId);
    }
    if (message.checklistTimeoutS !== undefined) {
      obj.checklistTimeoutS = Duration.toJSON(message.checklistTimeoutS);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobSettings>, I>>(base?: I): JobSettings {
    return JobSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobSettings>, I>>(object: I): JobSettings {
    const message = createBaseJobSettings();
    message.jobType = object.jobType ?? 0;
    message.checklistDefinitionId = object.checklistDefinitionId ?? 0;
    message.checklistTimeoutS = (object.checklistTimeoutS !== undefined && object.checklistTimeoutS !== null)
      ? Duration.fromPartial(object.checklistTimeoutS)
      : undefined;
    return message;
  },
};

function createBaseScvConnections(): ScvConnections {
  return { connections: [] };
}

export const ScvConnections: MessageFns<ScvConnections> = {
  encode(message: ScvConnections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      ScvConnection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvConnections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvConnections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connections.push(ScvConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvConnections {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => ScvConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScvConnections): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => ScvConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvConnections>, I>>(base?: I): ScvConnections {
    return ScvConnections.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvConnections>, I>>(object: I): ScvConnections {
    const message = createBaseScvConnections();
    message.connections = object.connections?.map((e) => ScvConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTractorArchetype(): TractorArchetype {
  return {
    id: "",
    dataModelVersion: 0,
    updatedAt: undefined,
    make: "",
    model: "",
    series: undefined,
    scvOutputs: undefined,
    frontPto: undefined,
    rearPto: undefined,
    steeringRange: undefined,
    minTurningRadiusM: 0,
    wheelSpacingM: 0,
    wheelbaseM: 0,
    driveType: 0,
    boundary: undefined,
    boundaryModel: undefined,
    hitches: undefined,
    calibration: undefined,
  };
}

export const TractorArchetype: MessageFns<TractorArchetype> = {
  encode(message: TractorArchetype, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.dataModelVersion !== 0) {
      writer.uint32(136).int32(message.dataModelVersion);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(114).fork()).join();
    }
    if (message.make !== "") {
      writer.uint32(18).string(message.make);
    }
    if (message.model !== "") {
      writer.uint32(26).string(message.model);
    }
    if (message.series !== undefined) {
      writer.uint32(34).string(message.series);
    }
    if (message.scvOutputs !== undefined) {
      ScvOutputs.encode(message.scvOutputs, writer.uint32(42).fork()).join();
    }
    if (message.frontPto !== undefined) {
      PtoConfig.encode(message.frontPto, writer.uint32(50).fork()).join();
    }
    if (message.rearPto !== undefined) {
      PtoConfig.encode(message.rearPto, writer.uint32(58).fork()).join();
    }
    if (message.steeringRange !== undefined) {
      SteeringRange.encode(message.steeringRange, writer.uint32(66).fork()).join();
    }
    if (message.minTurningRadiusM !== 0) {
      writer.uint32(121).double(message.minTurningRadiusM);
    }
    if (message.wheelSpacingM !== 0) {
      writer.uint32(73).double(message.wheelSpacingM);
    }
    if (message.wheelbaseM !== 0) {
      writer.uint32(81).double(message.wheelbaseM);
    }
    if (message.driveType !== 0) {
      writer.uint32(88).int32(message.driveType);
    }
    if (message.boundary !== undefined) {
      Polygon2D.encode(message.boundary, writer.uint32(98).fork()).join();
    }
    if (message.boundaryModel !== undefined) {
      TractorBoundaryModel.encode(message.boundaryModel, writer.uint32(146).fork()).join();
    }
    if (message.hitches !== undefined) {
      TractorHitches.encode(message.hitches, writer.uint32(106).fork()).join();
    }
    if (message.calibration !== undefined) {
      TractorCalibration.encode(message.calibration, writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorArchetype {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorArchetype();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.dataModelVersion = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.series = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scvOutputs = ScvOutputs.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.frontPto = PtoConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rearPto = PtoConfig.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.steeringRange = SteeringRange.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.minTurningRadiusM = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.wheelSpacingM = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.wheelbaseM = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.driveType = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.boundary = Polygon2D.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.boundaryModel = TractorBoundaryModel.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.hitches = TractorHitches.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.calibration = TractorCalibration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorArchetype {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      dataModelVersion: isSet(object.dataModelVersion)
        ? dataModelVersionFromJSON(object.dataModelVersion)
        : isSet(object.data_model_version)
        ? dataModelVersionFromJSON(object.data_model_version)
        : 0,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      series: isSet(object.series) ? globalThis.String(object.series) : undefined,
      scvOutputs: isSet(object.scvOutputs)
        ? ScvOutputs.fromJSON(object.scvOutputs)
        : isSet(object.scv_outputs)
        ? ScvOutputs.fromJSON(object.scv_outputs)
        : undefined,
      frontPto: isSet(object.frontPto)
        ? PtoConfig.fromJSON(object.frontPto)
        : isSet(object.front_pto)
        ? PtoConfig.fromJSON(object.front_pto)
        : undefined,
      rearPto: isSet(object.rearPto)
        ? PtoConfig.fromJSON(object.rearPto)
        : isSet(object.rear_pto)
        ? PtoConfig.fromJSON(object.rear_pto)
        : undefined,
      steeringRange: isSet(object.steeringRange)
        ? SteeringRange.fromJSON(object.steeringRange)
        : isSet(object.steering_range)
        ? SteeringRange.fromJSON(object.steering_range)
        : undefined,
      minTurningRadiusM: isSet(object.minTurningRadiusM)
        ? globalThis.Number(object.minTurningRadiusM)
        : isSet(object.min_turning_radius_m)
        ? globalThis.Number(object.min_turning_radius_m)
        : 0,
      wheelSpacingM: isSet(object.wheelSpacingM)
        ? globalThis.Number(object.wheelSpacingM)
        : isSet(object.wheel_spacing_m)
        ? globalThis.Number(object.wheel_spacing_m)
        : 0,
      wheelbaseM: isSet(object.wheelbaseM)
        ? globalThis.Number(object.wheelbaseM)
        : isSet(object.wheelbase_m)
        ? globalThis.Number(object.wheelbase_m)
        : 0,
      driveType: isSet(object.driveType)
        ? driveTypeFromJSON(object.driveType)
        : isSet(object.drive_type)
        ? driveTypeFromJSON(object.drive_type)
        : 0,
      boundary: isSet(object.boundary) ? Polygon2D.fromJSON(object.boundary) : undefined,
      boundaryModel: isSet(object.boundaryModel)
        ? TractorBoundaryModel.fromJSON(object.boundaryModel)
        : isSet(object.boundary_model)
        ? TractorBoundaryModel.fromJSON(object.boundary_model)
        : undefined,
      hitches: isSet(object.hitches) ? TractorHitches.fromJSON(object.hitches) : undefined,
      calibration: isSet(object.calibration) ? TractorCalibration.fromJSON(object.calibration) : undefined,
    };
  },

  toJSON(message: TractorArchetype): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.dataModelVersion !== 0) {
      obj.dataModelVersion = dataModelVersionToJSON(message.dataModelVersion);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.make !== "") {
      obj.make = message.make;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.series !== undefined) {
      obj.series = message.series;
    }
    if (message.scvOutputs !== undefined) {
      obj.scvOutputs = ScvOutputs.toJSON(message.scvOutputs);
    }
    if (message.frontPto !== undefined) {
      obj.frontPto = PtoConfig.toJSON(message.frontPto);
    }
    if (message.rearPto !== undefined) {
      obj.rearPto = PtoConfig.toJSON(message.rearPto);
    }
    if (message.steeringRange !== undefined) {
      obj.steeringRange = SteeringRange.toJSON(message.steeringRange);
    }
    if (message.minTurningRadiusM !== 0) {
      obj.minTurningRadiusM = message.minTurningRadiusM;
    }
    if (message.wheelSpacingM !== 0) {
      obj.wheelSpacingM = message.wheelSpacingM;
    }
    if (message.wheelbaseM !== 0) {
      obj.wheelbaseM = message.wheelbaseM;
    }
    if (message.driveType !== 0) {
      obj.driveType = driveTypeToJSON(message.driveType);
    }
    if (message.boundary !== undefined) {
      obj.boundary = Polygon2D.toJSON(message.boundary);
    }
    if (message.boundaryModel !== undefined) {
      obj.boundaryModel = TractorBoundaryModel.toJSON(message.boundaryModel);
    }
    if (message.hitches !== undefined) {
      obj.hitches = TractorHitches.toJSON(message.hitches);
    }
    if (message.calibration !== undefined) {
      obj.calibration = TractorCalibration.toJSON(message.calibration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorArchetype>, I>>(base?: I): TractorArchetype {
    return TractorArchetype.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorArchetype>, I>>(object: I): TractorArchetype {
    const message = createBaseTractorArchetype();
    message.id = object.id ?? "";
    message.dataModelVersion = object.dataModelVersion ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.make = object.make ?? "";
    message.model = object.model ?? "";
    message.series = object.series ?? undefined;
    message.scvOutputs = (object.scvOutputs !== undefined && object.scvOutputs !== null)
      ? ScvOutputs.fromPartial(object.scvOutputs)
      : undefined;
    message.frontPto = (object.frontPto !== undefined && object.frontPto !== null)
      ? PtoConfig.fromPartial(object.frontPto)
      : undefined;
    message.rearPto = (object.rearPto !== undefined && object.rearPto !== null)
      ? PtoConfig.fromPartial(object.rearPto)
      : undefined;
    message.steeringRange = (object.steeringRange !== undefined && object.steeringRange !== null)
      ? SteeringRange.fromPartial(object.steeringRange)
      : undefined;
    message.minTurningRadiusM = object.minTurningRadiusM ?? 0;
    message.wheelSpacingM = object.wheelSpacingM ?? 0;
    message.wheelbaseM = object.wheelbaseM ?? 0;
    message.driveType = object.driveType ?? 0;
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? Polygon2D.fromPartial(object.boundary)
      : undefined;
    message.boundaryModel = (object.boundaryModel !== undefined && object.boundaryModel !== null)
      ? TractorBoundaryModel.fromPartial(object.boundaryModel)
      : undefined;
    message.hitches = (object.hitches !== undefined && object.hitches !== null)
      ? TractorHitches.fromPartial(object.hitches)
      : undefined;
    message.calibration = (object.calibration !== undefined && object.calibration !== null)
      ? TractorCalibration.fromPartial(object.calibration)
      : undefined;
    return message;
  },
};

function createBaseTractor(): Tractor {
  return {
    id: "",
    customerId: "",
    customerUuid: "",
    dataModelVersion: 0,
    captureCompleted: false,
    updatedAt: undefined,
    name: "",
    archetype: undefined,
    scvOutputs: undefined,
    frontPto: undefined,
    rearPto: undefined,
    steeringRange: undefined,
    minTurningRadiusM: undefined,
    wheelSpacingM: undefined,
    boundary: undefined,
    boundaryModel: undefined,
    hitches: undefined,
    calibration: undefined,
  };
}

export const Tractor: MessageFns<Tractor> = {
  encode(message: Tractor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.customerId !== "") {
      writer.uint32(90).string(message.customerId);
    }
    if (message.customerUuid !== "") {
      writer.uint32(122).string(message.customerUuid);
    }
    if (message.dataModelVersion !== 0) {
      writer.uint32(128).int32(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      writer.uint32(136).bool(message.captureCompleted);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(98).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.archetype !== undefined) {
      TractorArchetype.encode(message.archetype, writer.uint32(26).fork()).join();
    }
    if (message.scvOutputs !== undefined) {
      ScvOutputs.encode(message.scvOutputs, writer.uint32(34).fork()).join();
    }
    if (message.frontPto !== undefined) {
      PtoConfig.encode(message.frontPto, writer.uint32(42).fork()).join();
    }
    if (message.rearPto !== undefined) {
      PtoConfig.encode(message.rearPto, writer.uint32(50).fork()).join();
    }
    if (message.steeringRange !== undefined) {
      SteeringRange.encode(message.steeringRange, writer.uint32(58).fork()).join();
    }
    if (message.minTurningRadiusM !== undefined) {
      writer.uint32(105).double(message.minTurningRadiusM);
    }
    if (message.wheelSpacingM !== undefined) {
      writer.uint32(65).double(message.wheelSpacingM);
    }
    if (message.boundary !== undefined) {
      Polygon2D.encode(message.boundary, writer.uint32(74).fork()).join();
    }
    if (message.boundaryModel !== undefined) {
      TractorBoundaryModel.encode(message.boundaryModel, writer.uint32(146).fork()).join();
    }
    if (message.hitches !== undefined) {
      TractorHitches.encode(message.hitches, writer.uint32(82).fork()).join();
    }
    if (message.calibration !== undefined) {
      TractorCalibration.encode(message.calibration, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Tractor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.customerUuid = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.dataModelVersion = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.captureCompleted = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.archetype = TractorArchetype.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scvOutputs = ScvOutputs.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.frontPto = PtoConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.rearPto = PtoConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.steeringRange = SteeringRange.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.minTurningRadiusM = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.wheelSpacingM = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.boundary = Polygon2D.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.boundaryModel = TractorBoundaryModel.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.hitches = TractorHitches.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.calibration = TractorCalibration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Tractor {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      customerUuid: isSet(object.customerUuid)
        ? globalThis.String(object.customerUuid)
        : isSet(object.customer_uuid)
        ? globalThis.String(object.customer_uuid)
        : "",
      dataModelVersion: isSet(object.dataModelVersion)
        ? dataModelVersionFromJSON(object.dataModelVersion)
        : isSet(object.data_model_version)
        ? dataModelVersionFromJSON(object.data_model_version)
        : 0,
      captureCompleted: isSet(object.captureCompleted)
        ? globalThis.Boolean(object.captureCompleted)
        : isSet(object.capture_completed)
        ? globalThis.Boolean(object.capture_completed)
        : false,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      archetype: isSet(object.archetype) ? TractorArchetype.fromJSON(object.archetype) : undefined,
      scvOutputs: isSet(object.scvOutputs)
        ? ScvOutputs.fromJSON(object.scvOutputs)
        : isSet(object.scv_outputs)
        ? ScvOutputs.fromJSON(object.scv_outputs)
        : undefined,
      frontPto: isSet(object.frontPto)
        ? PtoConfig.fromJSON(object.frontPto)
        : isSet(object.front_pto)
        ? PtoConfig.fromJSON(object.front_pto)
        : undefined,
      rearPto: isSet(object.rearPto)
        ? PtoConfig.fromJSON(object.rearPto)
        : isSet(object.rear_pto)
        ? PtoConfig.fromJSON(object.rear_pto)
        : undefined,
      steeringRange: isSet(object.steeringRange)
        ? SteeringRange.fromJSON(object.steeringRange)
        : isSet(object.steering_range)
        ? SteeringRange.fromJSON(object.steering_range)
        : undefined,
      minTurningRadiusM: isSet(object.minTurningRadiusM)
        ? globalThis.Number(object.minTurningRadiusM)
        : isSet(object.min_turning_radius_m)
        ? globalThis.Number(object.min_turning_radius_m)
        : undefined,
      wheelSpacingM: isSet(object.wheelSpacingM)
        ? globalThis.Number(object.wheelSpacingM)
        : isSet(object.wheel_spacing_m)
        ? globalThis.Number(object.wheel_spacing_m)
        : undefined,
      boundary: isSet(object.boundary) ? Polygon2D.fromJSON(object.boundary) : undefined,
      boundaryModel: isSet(object.boundaryModel)
        ? TractorBoundaryModel.fromJSON(object.boundaryModel)
        : isSet(object.boundary_model)
        ? TractorBoundaryModel.fromJSON(object.boundary_model)
        : undefined,
      hitches: isSet(object.hitches) ? TractorHitches.fromJSON(object.hitches) : undefined,
      calibration: isSet(object.calibration) ? TractorCalibration.fromJSON(object.calibration) : undefined,
    };
  },

  toJSON(message: Tractor): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.customerUuid !== "") {
      obj.customerUuid = message.customerUuid;
    }
    if (message.dataModelVersion !== 0) {
      obj.dataModelVersion = dataModelVersionToJSON(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      obj.captureCompleted = message.captureCompleted;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.archetype !== undefined) {
      obj.archetype = TractorArchetype.toJSON(message.archetype);
    }
    if (message.scvOutputs !== undefined) {
      obj.scvOutputs = ScvOutputs.toJSON(message.scvOutputs);
    }
    if (message.frontPto !== undefined) {
      obj.frontPto = PtoConfig.toJSON(message.frontPto);
    }
    if (message.rearPto !== undefined) {
      obj.rearPto = PtoConfig.toJSON(message.rearPto);
    }
    if (message.steeringRange !== undefined) {
      obj.steeringRange = SteeringRange.toJSON(message.steeringRange);
    }
    if (message.minTurningRadiusM !== undefined) {
      obj.minTurningRadiusM = message.minTurningRadiusM;
    }
    if (message.wheelSpacingM !== undefined) {
      obj.wheelSpacingM = message.wheelSpacingM;
    }
    if (message.boundary !== undefined) {
      obj.boundary = Polygon2D.toJSON(message.boundary);
    }
    if (message.boundaryModel !== undefined) {
      obj.boundaryModel = TractorBoundaryModel.toJSON(message.boundaryModel);
    }
    if (message.hitches !== undefined) {
      obj.hitches = TractorHitches.toJSON(message.hitches);
    }
    if (message.calibration !== undefined) {
      obj.calibration = TractorCalibration.toJSON(message.calibration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Tractor>, I>>(base?: I): Tractor {
    return Tractor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Tractor>, I>>(object: I): Tractor {
    const message = createBaseTractor();
    message.id = object.id ?? "";
    message.customerId = object.customerId ?? "";
    message.customerUuid = object.customerUuid ?? "";
    message.dataModelVersion = object.dataModelVersion ?? 0;
    message.captureCompleted = object.captureCompleted ?? false;
    message.updatedAt = object.updatedAt ?? undefined;
    message.name = object.name ?? "";
    message.archetype = (object.archetype !== undefined && object.archetype !== null)
      ? TractorArchetype.fromPartial(object.archetype)
      : undefined;
    message.scvOutputs = (object.scvOutputs !== undefined && object.scvOutputs !== null)
      ? ScvOutputs.fromPartial(object.scvOutputs)
      : undefined;
    message.frontPto = (object.frontPto !== undefined && object.frontPto !== null)
      ? PtoConfig.fromPartial(object.frontPto)
      : undefined;
    message.rearPto = (object.rearPto !== undefined && object.rearPto !== null)
      ? PtoConfig.fromPartial(object.rearPto)
      : undefined;
    message.steeringRange = (object.steeringRange !== undefined && object.steeringRange !== null)
      ? SteeringRange.fromPartial(object.steeringRange)
      : undefined;
    message.minTurningRadiusM = object.minTurningRadiusM ?? undefined;
    message.wheelSpacingM = object.wheelSpacingM ?? undefined;
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? Polygon2D.fromPartial(object.boundary)
      : undefined;
    message.boundaryModel = (object.boundaryModel !== undefined && object.boundaryModel !== null)
      ? TractorBoundaryModel.fromPartial(object.boundaryModel)
      : undefined;
    message.hitches = (object.hitches !== undefined && object.hitches !== null)
      ? TractorHitches.fromPartial(object.hitches)
      : undefined;
    message.calibration = (object.calibration !== undefined && object.calibration !== null)
      ? TractorCalibration.fromPartial(object.calibration)
      : undefined;
    return message;
  },
};

function createBaseTractorHitches(): TractorHitches {
  return { hitches: [] };
}

export const TractorHitches: MessageFns<TractorHitches> = {
  encode(message: TractorHitches, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.hitches) {
      TractorHitch.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorHitches {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorHitches();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hitches.push(TractorHitch.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorHitches {
    return {
      hitches: globalThis.Array.isArray(object?.hitches)
        ? object.hitches.map((e: any) => TractorHitch.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TractorHitches): unknown {
    const obj: any = {};
    if (message.hitches?.length) {
      obj.hitches = message.hitches.map((e) => TractorHitch.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorHitches>, I>>(base?: I): TractorHitches {
    return TractorHitches.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorHitches>, I>>(object: I): TractorHitches {
    const message = createBaseTractorHitches();
    message.hitches = object.hitches?.map((e) => TractorHitch.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSteeringRange(): SteeringRange {
  return { min: 0, max: 0 };
}

export const SteeringRange: MessageFns<SteeringRange> = {
  encode(message: SteeringRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(9).double(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(17).double(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SteeringRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSteeringRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.min = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.max = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SteeringRange {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
    };
  },

  toJSON(message: SteeringRange): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = message.min;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SteeringRange>, I>>(base?: I): SteeringRange {
    return SteeringRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SteeringRange>, I>>(object: I): SteeringRange {
    const message = createBaseSteeringRange();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    return message;
  },
};

function createBasePtoRequirements(): PtoRequirements {
  return { type: 0, engineSpeedRpm: 0, ptoSpeed: 0 };
}

export const PtoRequirements: MessageFns<PtoRequirements> = {
  encode(message: PtoRequirements, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.engineSpeedRpm !== 0) {
      writer.uint32(16).int32(message.engineSpeedRpm);
    }
    if (message.ptoSpeed !== 0) {
      writer.uint32(24).int32(message.ptoSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PtoRequirements {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePtoRequirements();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.engineSpeedRpm = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ptoSpeed = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PtoRequirements {
    return {
      type: isSet(object.type) ? ptoTypeFromJSON(object.type) : 0,
      engineSpeedRpm: isSet(object.engineSpeedRpm)
        ? globalThis.Number(object.engineSpeedRpm)
        : isSet(object.engine_speed_rpm)
        ? globalThis.Number(object.engine_speed_rpm)
        : 0,
      ptoSpeed: isSet(object.ptoSpeed)
        ? ptoSpeedFromJSON(object.ptoSpeed)
        : isSet(object.pto_speed)
        ? ptoSpeedFromJSON(object.pto_speed)
        : 0,
    };
  },

  toJSON(message: PtoRequirements): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = ptoTypeToJSON(message.type);
    }
    if (message.engineSpeedRpm !== 0) {
      obj.engineSpeedRpm = Math.round(message.engineSpeedRpm);
    }
    if (message.ptoSpeed !== 0) {
      obj.ptoSpeed = ptoSpeedToJSON(message.ptoSpeed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PtoRequirements>, I>>(base?: I): PtoRequirements {
    return PtoRequirements.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PtoRequirements>, I>>(object: I): PtoRequirements {
    const message = createBasePtoRequirements();
    message.type = object.type ?? 0;
    message.engineSpeedRpm = object.engineSpeedRpm ?? 0;
    message.ptoSpeed = object.ptoSpeed ?? 0;
    return message;
  },
};

function createBaseImplementHeightTurningRadiusLimit(): ImplementHeightTurningRadiusLimit {
  return { maxHeight: 0, minTurningRadiusM: 0 };
}

export const ImplementHeightTurningRadiusLimit: MessageFns<ImplementHeightTurningRadiusLimit> = {
  encode(message: ImplementHeightTurningRadiusLimit, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxHeight !== 0) {
      writer.uint32(9).double(message.maxHeight);
    }
    if (message.minTurningRadiusM !== 0) {
      writer.uint32(17).double(message.minTurningRadiusM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementHeightTurningRadiusLimit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementHeightTurningRadiusLimit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.maxHeight = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.minTurningRadiusM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementHeightTurningRadiusLimit {
    return {
      maxHeight: isSet(object.maxHeight)
        ? globalThis.Number(object.maxHeight)
        : isSet(object.max_height)
        ? globalThis.Number(object.max_height)
        : 0,
      minTurningRadiusM: isSet(object.minTurningRadiusM)
        ? globalThis.Number(object.minTurningRadiusM)
        : isSet(object.min_turning_radius_m)
        ? globalThis.Number(object.min_turning_radius_m)
        : 0,
    };
  },

  toJSON(message: ImplementHeightTurningRadiusLimit): unknown {
    const obj: any = {};
    if (message.maxHeight !== 0) {
      obj.maxHeight = message.maxHeight;
    }
    if (message.minTurningRadiusM !== 0) {
      obj.minTurningRadiusM = message.minTurningRadiusM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementHeightTurningRadiusLimit>, I>>(
    base?: I,
  ): ImplementHeightTurningRadiusLimit {
    return ImplementHeightTurningRadiusLimit.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementHeightTurningRadiusLimit>, I>>(
    object: I,
  ): ImplementHeightTurningRadiusLimit {
    const message = createBaseImplementHeightTurningRadiusLimit();
    message.maxHeight = object.maxHeight ?? 0;
    message.minTurningRadiusM = object.minTurningRadiusM ?? 0;
    return message;
  },
};

function createBaseImplementSensors(): ImplementSensors {
  return { ioLinkSensors: [] };
}

export const ImplementSensors: MessageFns<ImplementSensors> = {
  encode(message: ImplementSensors, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ioLinkSensors) {
      IOLinkRegisterDevice.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementSensors {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementSensors();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ioLinkSensors.push(IOLinkRegisterDevice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementSensors {
    return {
      ioLinkSensors: globalThis.Array.isArray(object?.ioLinkSensors)
        ? object.ioLinkSensors.map((e: any) => IOLinkRegisterDevice.fromJSON(e))
        : globalThis.Array.isArray(object?.io_link_sensors)
        ? object.io_link_sensors.map((e: any) => IOLinkRegisterDevice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ImplementSensors): unknown {
    const obj: any = {};
    if (message.ioLinkSensors?.length) {
      obj.ioLinkSensors = message.ioLinkSensors.map((e) => IOLinkRegisterDevice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementSensors>, I>>(base?: I): ImplementSensors {
    return ImplementSensors.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementSensors>, I>>(object: I): ImplementSensors {
    const message = createBaseImplementSensors();
    message.ioLinkSensors = object.ioLinkSensors?.map((e) => IOLinkRegisterDevice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseImplementArchetype(): ImplementArchetype {
  return {
    id: "",
    dataModelVersion: 0,
    updatedAt: undefined,
    make: "",
    model: "",
    series: undefined,
    hitchType: 0,
    ptoRequirements: undefined,
    scvInputs: undefined,
    atim: undefined,
    workingWidthM: 0,
    workingWidthMLeft: undefined,
    workingWidthMRight: undefined,
    workingStartOffsetM: 0,
    workingEndOffsetM: 0,
    turnDirection: undefined,
    toolSpeedMS: 0,
    transitionSpeedMS: 0,
    runUpDistanceM: 0,
    straightenDistanceM: 0,
    turningRadiusLimits: [],
    boundary: undefined,
    boundaryModel: undefined,
    calibration: undefined,
    sensors: undefined,
  };
}

export const ImplementArchetype: MessageFns<ImplementArchetype> = {
  encode(message: ImplementArchetype, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.dataModelVersion !== 0) {
      writer.uint32(176).int32(message.dataModelVersion);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(154).fork()).join();
    }
    if (message.make !== "") {
      writer.uint32(18).string(message.make);
    }
    if (message.model !== "") {
      writer.uint32(26).string(message.model);
    }
    if (message.series !== undefined) {
      writer.uint32(34).string(message.series);
    }
    if (message.hitchType !== 0) {
      writer.uint32(40).int32(message.hitchType);
    }
    if (message.ptoRequirements !== undefined) {
      PtoRequirements.encode(message.ptoRequirements, writer.uint32(50).fork()).join();
    }
    if (message.scvInputs !== undefined) {
      ScvInputs.encode(message.scvInputs, writer.uint32(58).fork()).join();
    }
    if (message.atim !== undefined) {
      writer.uint32(72).int32(message.atim);
    }
    if (message.workingWidthM !== 0) {
      writer.uint32(81).double(message.workingWidthM);
    }
    if (message.workingWidthMLeft !== undefined) {
      writer.uint32(193).double(message.workingWidthMLeft);
    }
    if (message.workingWidthMRight !== undefined) {
      writer.uint32(201).double(message.workingWidthMRight);
    }
    if (message.workingStartOffsetM !== 0) {
      writer.uint32(89).double(message.workingStartOffsetM);
    }
    if (message.workingEndOffsetM !== 0) {
      writer.uint32(97).double(message.workingEndOffsetM);
    }
    if (message.turnDirection !== undefined) {
      writer.uint32(224).int32(message.turnDirection);
    }
    if (message.toolSpeedMS !== 0) {
      writer.uint32(105).double(message.toolSpeedMS);
    }
    if (message.transitionSpeedMS !== 0) {
      writer.uint32(113).double(message.transitionSpeedMS);
    }
    if (message.runUpDistanceM !== 0) {
      writer.uint32(121).double(message.runUpDistanceM);
    }
    if (message.straightenDistanceM !== 0) {
      writer.uint32(129).double(message.straightenDistanceM);
    }
    for (const v of message.turningRadiusLimits) {
      ImplementHeightTurningRadiusLimit.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.boundary !== undefined) {
      Polygon2D.encode(message.boundary, writer.uint32(138).fork()).join();
    }
    if (message.boundaryModel !== undefined) {
      ImplementBoundaryModel.encode(message.boundaryModel, writer.uint32(218).fork()).join();
    }
    if (message.calibration !== undefined) {
      ImplementCalibration.encode(message.calibration, writer.uint32(170).fork()).join();
    }
    if (message.sensors !== undefined) {
      ImplementSensors.encode(message.sensors, writer.uint32(210).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementArchetype {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementArchetype();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.dataModelVersion = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.series = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.hitchType = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ptoRequirements = PtoRequirements.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.scvInputs = ScvInputs.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.atim = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.workingWidthM = reader.double();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.workingWidthMLeft = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 201) {
            break;
          }

          message.workingWidthMRight = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.workingStartOffsetM = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.workingEndOffsetM = reader.double();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.turnDirection = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.toolSpeedMS = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.runUpDistanceM = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.straightenDistanceM = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.turningRadiusLimits.push(ImplementHeightTurningRadiusLimit.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.boundary = Polygon2D.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.boundaryModel = ImplementBoundaryModel.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.calibration = ImplementCalibration.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.sensors = ImplementSensors.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementArchetype {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      dataModelVersion: isSet(object.dataModelVersion)
        ? dataModelVersionFromJSON(object.dataModelVersion)
        : isSet(object.data_model_version)
        ? dataModelVersionFromJSON(object.data_model_version)
        : 0,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
      series: isSet(object.series) ? globalThis.String(object.series) : undefined,
      hitchType: isSet(object.hitchType)
        ? hitchTypeFromJSON(object.hitchType)
        : isSet(object.hitch_type)
        ? hitchTypeFromJSON(object.hitch_type)
        : 0,
      ptoRequirements: isSet(object.ptoRequirements)
        ? PtoRequirements.fromJSON(object.ptoRequirements)
        : isSet(object.pto_requirements)
        ? PtoRequirements.fromJSON(object.pto_requirements)
        : undefined,
      scvInputs: isSet(object.scvInputs)
        ? ScvInputs.fromJSON(object.scvInputs)
        : isSet(object.scv_inputs)
        ? ScvInputs.fromJSON(object.scv_inputs)
        : undefined,
      atim: isSet(object.atim) ? atimInterfaceFromJSON(object.atim) : undefined,
      workingWidthM: isSet(object.workingWidthM)
        ? globalThis.Number(object.workingWidthM)
        : isSet(object.working_width_m)
        ? globalThis.Number(object.working_width_m)
        : 0,
      workingWidthMLeft: isSet(object.workingWidthMLeft)
        ? globalThis.Number(object.workingWidthMLeft)
        : isSet(object.working_width_m_left)
        ? globalThis.Number(object.working_width_m_left)
        : undefined,
      workingWidthMRight: isSet(object.workingWidthMRight)
        ? globalThis.Number(object.workingWidthMRight)
        : isSet(object.working_width_m_right)
        ? globalThis.Number(object.working_width_m_right)
        : undefined,
      workingStartOffsetM: isSet(object.workingStartOffsetM)
        ? globalThis.Number(object.workingStartOffsetM)
        : isSet(object.working_start_offset_m)
        ? globalThis.Number(object.working_start_offset_m)
        : 0,
      workingEndOffsetM: isSet(object.workingEndOffsetM)
        ? globalThis.Number(object.workingEndOffsetM)
        : isSet(object.working_end_offset_m)
        ? globalThis.Number(object.working_end_offset_m)
        : 0,
      turnDirection: isSet(object.turnDirection)
        ? turnDirectionFromJSON(object.turnDirection)
        : isSet(object.turn_direction)
        ? turnDirectionFromJSON(object.turn_direction)
        : undefined,
      toolSpeedMS: isSet(object.toolSpeedMS)
        ? globalThis.Number(object.toolSpeedMS)
        : isSet(object.tool_speed_m_s)
        ? globalThis.Number(object.tool_speed_m_s)
        : 0,
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : 0,
      runUpDistanceM: isSet(object.runUpDistanceM)
        ? globalThis.Number(object.runUpDistanceM)
        : isSet(object.run_up_distance_m)
        ? globalThis.Number(object.run_up_distance_m)
        : 0,
      straightenDistanceM: isSet(object.straightenDistanceM)
        ? globalThis.Number(object.straightenDistanceM)
        : isSet(object.straighten_distance_m)
        ? globalThis.Number(object.straighten_distance_m)
        : 0,
      turningRadiusLimits: globalThis.Array.isArray(object?.turningRadiusLimits)
        ? object.turningRadiusLimits.map((e: any) => ImplementHeightTurningRadiusLimit.fromJSON(e))
        : globalThis.Array.isArray(object?.turning_radius_limits)
        ? object.turning_radius_limits.map((e: any) => ImplementHeightTurningRadiusLimit.fromJSON(e))
        : [],
      boundary: isSet(object.boundary) ? Polygon2D.fromJSON(object.boundary) : undefined,
      boundaryModel: isSet(object.boundaryModel)
        ? ImplementBoundaryModel.fromJSON(object.boundaryModel)
        : isSet(object.boundary_model)
        ? ImplementBoundaryModel.fromJSON(object.boundary_model)
        : undefined,
      calibration: isSet(object.calibration) ? ImplementCalibration.fromJSON(object.calibration) : undefined,
      sensors: isSet(object.sensors) ? ImplementSensors.fromJSON(object.sensors) : undefined,
    };
  },

  toJSON(message: ImplementArchetype): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.dataModelVersion !== 0) {
      obj.dataModelVersion = dataModelVersionToJSON(message.dataModelVersion);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.make !== "") {
      obj.make = message.make;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    if (message.series !== undefined) {
      obj.series = message.series;
    }
    if (message.hitchType !== 0) {
      obj.hitchType = hitchTypeToJSON(message.hitchType);
    }
    if (message.ptoRequirements !== undefined) {
      obj.ptoRequirements = PtoRequirements.toJSON(message.ptoRequirements);
    }
    if (message.scvInputs !== undefined) {
      obj.scvInputs = ScvInputs.toJSON(message.scvInputs);
    }
    if (message.atim !== undefined) {
      obj.atim = atimInterfaceToJSON(message.atim);
    }
    if (message.workingWidthM !== 0) {
      obj.workingWidthM = message.workingWidthM;
    }
    if (message.workingWidthMLeft !== undefined) {
      obj.workingWidthMLeft = message.workingWidthMLeft;
    }
    if (message.workingWidthMRight !== undefined) {
      obj.workingWidthMRight = message.workingWidthMRight;
    }
    if (message.workingStartOffsetM !== 0) {
      obj.workingStartOffsetM = message.workingStartOffsetM;
    }
    if (message.workingEndOffsetM !== 0) {
      obj.workingEndOffsetM = message.workingEndOffsetM;
    }
    if (message.turnDirection !== undefined) {
      obj.turnDirection = turnDirectionToJSON(message.turnDirection);
    }
    if (message.toolSpeedMS !== 0) {
      obj.toolSpeedMS = message.toolSpeedMS;
    }
    if (message.transitionSpeedMS !== 0) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    if (message.runUpDistanceM !== 0) {
      obj.runUpDistanceM = message.runUpDistanceM;
    }
    if (message.straightenDistanceM !== 0) {
      obj.straightenDistanceM = message.straightenDistanceM;
    }
    if (message.turningRadiusLimits?.length) {
      obj.turningRadiusLimits = message.turningRadiusLimits.map((e) => ImplementHeightTurningRadiusLimit.toJSON(e));
    }
    if (message.boundary !== undefined) {
      obj.boundary = Polygon2D.toJSON(message.boundary);
    }
    if (message.boundaryModel !== undefined) {
      obj.boundaryModel = ImplementBoundaryModel.toJSON(message.boundaryModel);
    }
    if (message.calibration !== undefined) {
      obj.calibration = ImplementCalibration.toJSON(message.calibration);
    }
    if (message.sensors !== undefined) {
      obj.sensors = ImplementSensors.toJSON(message.sensors);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementArchetype>, I>>(base?: I): ImplementArchetype {
    return ImplementArchetype.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementArchetype>, I>>(object: I): ImplementArchetype {
    const message = createBaseImplementArchetype();
    message.id = object.id ?? "";
    message.dataModelVersion = object.dataModelVersion ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.make = object.make ?? "";
    message.model = object.model ?? "";
    message.series = object.series ?? undefined;
    message.hitchType = object.hitchType ?? 0;
    message.ptoRequirements = (object.ptoRequirements !== undefined && object.ptoRequirements !== null)
      ? PtoRequirements.fromPartial(object.ptoRequirements)
      : undefined;
    message.scvInputs = (object.scvInputs !== undefined && object.scvInputs !== null)
      ? ScvInputs.fromPartial(object.scvInputs)
      : undefined;
    message.atim = object.atim ?? undefined;
    message.workingWidthM = object.workingWidthM ?? 0;
    message.workingWidthMLeft = object.workingWidthMLeft ?? undefined;
    message.workingWidthMRight = object.workingWidthMRight ?? undefined;
    message.workingStartOffsetM = object.workingStartOffsetM ?? 0;
    message.workingEndOffsetM = object.workingEndOffsetM ?? 0;
    message.turnDirection = object.turnDirection ?? undefined;
    message.toolSpeedMS = object.toolSpeedMS ?? 0;
    message.transitionSpeedMS = object.transitionSpeedMS ?? 0;
    message.runUpDistanceM = object.runUpDistanceM ?? 0;
    message.straightenDistanceM = object.straightenDistanceM ?? 0;
    message.turningRadiusLimits =
      object.turningRadiusLimits?.map((e) => ImplementHeightTurningRadiusLimit.fromPartial(e)) || [];
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? Polygon2D.fromPartial(object.boundary)
      : undefined;
    message.boundaryModel = (object.boundaryModel !== undefined && object.boundaryModel !== null)
      ? ImplementBoundaryModel.fromPartial(object.boundaryModel)
      : undefined;
    message.calibration = (object.calibration !== undefined && object.calibration !== null)
      ? ImplementCalibration.fromPartial(object.calibration)
      : undefined;
    message.sensors = (object.sensors !== undefined && object.sensors !== null)
      ? ImplementSensors.fromPartial(object.sensors)
      : undefined;
    return message;
  },
};

function createBaseImplement(): Implement {
  return {
    id: "",
    customerId: "",
    customerUuid: "",
    dataModelVersion: 0,
    captureCompleted: false,
    updatedAt: undefined,
    name: "",
    archetype: undefined,
    hitchType: undefined,
    ptoRequirements: undefined,
    scvInputs: undefined,
    atim: undefined,
    workingWidthM: undefined,
    workingWidthMLeft: undefined,
    workingWidthMRight: undefined,
    workingStartOffsetM: undefined,
    workingEndOffsetM: undefined,
    turnDirection: undefined,
    toolSpeedMS: undefined,
    transitionSpeedMS: undefined,
    runUpDistanceM: undefined,
    straightenDistanceM: undefined,
    turningRadiusLimits: [],
    boundary: undefined,
    boundaryModel: undefined,
    calibration: undefined,
    sensors: undefined,
  };
}

export const Implement: MessageFns<Implement> = {
  encode(message: Implement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.customerId !== "") {
      writer.uint32(138).string(message.customerId);
    }
    if (message.customerUuid !== "") {
      writer.uint32(178).string(message.customerUuid);
    }
    if (message.dataModelVersion !== 0) {
      writer.uint32(168).int32(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      writer.uint32(184).bool(message.captureCompleted);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(146).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.archetype !== undefined) {
      ImplementArchetype.encode(message.archetype, writer.uint32(26).fork()).join();
    }
    if (message.hitchType !== undefined) {
      writer.uint32(32).int32(message.hitchType);
    }
    if (message.ptoRequirements !== undefined) {
      PtoRequirements.encode(message.ptoRequirements, writer.uint32(42).fork()).join();
    }
    if (message.scvInputs !== undefined) {
      ScvInputs.encode(message.scvInputs, writer.uint32(50).fork()).join();
    }
    if (message.atim !== undefined) {
      writer.uint32(56).int32(message.atim);
    }
    if (message.workingWidthM !== undefined) {
      writer.uint32(65).double(message.workingWidthM);
    }
    if (message.workingWidthMLeft !== undefined) {
      writer.uint32(193).double(message.workingWidthMLeft);
    }
    if (message.workingWidthMRight !== undefined) {
      writer.uint32(201).double(message.workingWidthMRight);
    }
    if (message.workingStartOffsetM !== undefined) {
      writer.uint32(73).double(message.workingStartOffsetM);
    }
    if (message.workingEndOffsetM !== undefined) {
      writer.uint32(81).double(message.workingEndOffsetM);
    }
    if (message.turnDirection !== undefined) {
      writer.uint32(224).int32(message.turnDirection);
    }
    if (message.toolSpeedMS !== undefined) {
      writer.uint32(89).double(message.toolSpeedMS);
    }
    if (message.transitionSpeedMS !== undefined) {
      writer.uint32(97).double(message.transitionSpeedMS);
    }
    if (message.runUpDistanceM !== undefined) {
      writer.uint32(105).double(message.runUpDistanceM);
    }
    if (message.straightenDistanceM !== undefined) {
      writer.uint32(113).double(message.straightenDistanceM);
    }
    for (const v of message.turningRadiusLimits) {
      ImplementHeightTurningRadiusLimit.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.boundary !== undefined) {
      Polygon2D.encode(message.boundary, writer.uint32(122).fork()).join();
    }
    if (message.boundaryModel !== undefined) {
      ImplementBoundaryModel.encode(message.boundaryModel, writer.uint32(218).fork()).join();
    }
    if (message.calibration !== undefined) {
      ImplementCalibration.encode(message.calibration, writer.uint32(154).fork()).join();
    }
    if (message.sensors !== undefined) {
      ImplementSensors.encode(message.sensors, writer.uint32(210).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Implement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.customerUuid = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.dataModelVersion = reader.int32() as any;
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.captureCompleted = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.archetype = ImplementArchetype.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.hitchType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ptoRequirements = PtoRequirements.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scvInputs = ScvInputs.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.atim = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.workingWidthM = reader.double();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.workingWidthMLeft = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 201) {
            break;
          }

          message.workingWidthMRight = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.workingStartOffsetM = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.workingEndOffsetM = reader.double();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.turnDirection = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.toolSpeedMS = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.runUpDistanceM = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.straightenDistanceM = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.turningRadiusLimits.push(ImplementHeightTurningRadiusLimit.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.boundary = Polygon2D.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.boundaryModel = ImplementBoundaryModel.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.calibration = ImplementCalibration.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.sensors = ImplementSensors.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Implement {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      customerUuid: isSet(object.customerUuid)
        ? globalThis.String(object.customerUuid)
        : isSet(object.customer_uuid)
        ? globalThis.String(object.customer_uuid)
        : "",
      dataModelVersion: isSet(object.dataModelVersion)
        ? dataModelVersionFromJSON(object.dataModelVersion)
        : isSet(object.data_model_version)
        ? dataModelVersionFromJSON(object.data_model_version)
        : 0,
      captureCompleted: isSet(object.captureCompleted)
        ? globalThis.Boolean(object.captureCompleted)
        : isSet(object.capture_completed)
        ? globalThis.Boolean(object.capture_completed)
        : false,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      archetype: isSet(object.archetype) ? ImplementArchetype.fromJSON(object.archetype) : undefined,
      hitchType: isSet(object.hitchType)
        ? hitchTypeFromJSON(object.hitchType)
        : isSet(object.hitch_type)
        ? hitchTypeFromJSON(object.hitch_type)
        : undefined,
      ptoRequirements: isSet(object.ptoRequirements)
        ? PtoRequirements.fromJSON(object.ptoRequirements)
        : isSet(object.pto_requirements)
        ? PtoRequirements.fromJSON(object.pto_requirements)
        : undefined,
      scvInputs: isSet(object.scvInputs)
        ? ScvInputs.fromJSON(object.scvInputs)
        : isSet(object.scv_inputs)
        ? ScvInputs.fromJSON(object.scv_inputs)
        : undefined,
      atim: isSet(object.atim) ? atimInterfaceFromJSON(object.atim) : undefined,
      workingWidthM: isSet(object.workingWidthM)
        ? globalThis.Number(object.workingWidthM)
        : isSet(object.working_width_m)
        ? globalThis.Number(object.working_width_m)
        : undefined,
      workingWidthMLeft: isSet(object.workingWidthMLeft)
        ? globalThis.Number(object.workingWidthMLeft)
        : isSet(object.working_width_m_left)
        ? globalThis.Number(object.working_width_m_left)
        : undefined,
      workingWidthMRight: isSet(object.workingWidthMRight)
        ? globalThis.Number(object.workingWidthMRight)
        : isSet(object.working_width_m_right)
        ? globalThis.Number(object.working_width_m_right)
        : undefined,
      workingStartOffsetM: isSet(object.workingStartOffsetM)
        ? globalThis.Number(object.workingStartOffsetM)
        : isSet(object.working_start_offset_m)
        ? globalThis.Number(object.working_start_offset_m)
        : undefined,
      workingEndOffsetM: isSet(object.workingEndOffsetM)
        ? globalThis.Number(object.workingEndOffsetM)
        : isSet(object.working_end_offset_m)
        ? globalThis.Number(object.working_end_offset_m)
        : undefined,
      turnDirection: isSet(object.turnDirection)
        ? turnDirectionFromJSON(object.turnDirection)
        : isSet(object.turn_direction)
        ? turnDirectionFromJSON(object.turn_direction)
        : undefined,
      toolSpeedMS: isSet(object.toolSpeedMS)
        ? globalThis.Number(object.toolSpeedMS)
        : isSet(object.tool_speed_m_s)
        ? globalThis.Number(object.tool_speed_m_s)
        : undefined,
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : undefined,
      runUpDistanceM: isSet(object.runUpDistanceM)
        ? globalThis.Number(object.runUpDistanceM)
        : isSet(object.run_up_distance_m)
        ? globalThis.Number(object.run_up_distance_m)
        : undefined,
      straightenDistanceM: isSet(object.straightenDistanceM)
        ? globalThis.Number(object.straightenDistanceM)
        : isSet(object.straighten_distance_m)
        ? globalThis.Number(object.straighten_distance_m)
        : undefined,
      turningRadiusLimits: globalThis.Array.isArray(object?.turningRadiusLimits)
        ? object.turningRadiusLimits.map((e: any) => ImplementHeightTurningRadiusLimit.fromJSON(e))
        : globalThis.Array.isArray(object?.turning_radius_limits)
        ? object.turning_radius_limits.map((e: any) => ImplementHeightTurningRadiusLimit.fromJSON(e))
        : [],
      boundary: isSet(object.boundary) ? Polygon2D.fromJSON(object.boundary) : undefined,
      boundaryModel: isSet(object.boundaryModel)
        ? ImplementBoundaryModel.fromJSON(object.boundaryModel)
        : isSet(object.boundary_model)
        ? ImplementBoundaryModel.fromJSON(object.boundary_model)
        : undefined,
      calibration: isSet(object.calibration) ? ImplementCalibration.fromJSON(object.calibration) : undefined,
      sensors: isSet(object.sensors) ? ImplementSensors.fromJSON(object.sensors) : undefined,
    };
  },

  toJSON(message: Implement): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.customerUuid !== "") {
      obj.customerUuid = message.customerUuid;
    }
    if (message.dataModelVersion !== 0) {
      obj.dataModelVersion = dataModelVersionToJSON(message.dataModelVersion);
    }
    if (message.captureCompleted !== false) {
      obj.captureCompleted = message.captureCompleted;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.archetype !== undefined) {
      obj.archetype = ImplementArchetype.toJSON(message.archetype);
    }
    if (message.hitchType !== undefined) {
      obj.hitchType = hitchTypeToJSON(message.hitchType);
    }
    if (message.ptoRequirements !== undefined) {
      obj.ptoRequirements = PtoRequirements.toJSON(message.ptoRequirements);
    }
    if (message.scvInputs !== undefined) {
      obj.scvInputs = ScvInputs.toJSON(message.scvInputs);
    }
    if (message.atim !== undefined) {
      obj.atim = atimInterfaceToJSON(message.atim);
    }
    if (message.workingWidthM !== undefined) {
      obj.workingWidthM = message.workingWidthM;
    }
    if (message.workingWidthMLeft !== undefined) {
      obj.workingWidthMLeft = message.workingWidthMLeft;
    }
    if (message.workingWidthMRight !== undefined) {
      obj.workingWidthMRight = message.workingWidthMRight;
    }
    if (message.workingStartOffsetM !== undefined) {
      obj.workingStartOffsetM = message.workingStartOffsetM;
    }
    if (message.workingEndOffsetM !== undefined) {
      obj.workingEndOffsetM = message.workingEndOffsetM;
    }
    if (message.turnDirection !== undefined) {
      obj.turnDirection = turnDirectionToJSON(message.turnDirection);
    }
    if (message.toolSpeedMS !== undefined) {
      obj.toolSpeedMS = message.toolSpeedMS;
    }
    if (message.transitionSpeedMS !== undefined) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    if (message.runUpDistanceM !== undefined) {
      obj.runUpDistanceM = message.runUpDistanceM;
    }
    if (message.straightenDistanceM !== undefined) {
      obj.straightenDistanceM = message.straightenDistanceM;
    }
    if (message.turningRadiusLimits?.length) {
      obj.turningRadiusLimits = message.turningRadiusLimits.map((e) => ImplementHeightTurningRadiusLimit.toJSON(e));
    }
    if (message.boundary !== undefined) {
      obj.boundary = Polygon2D.toJSON(message.boundary);
    }
    if (message.boundaryModel !== undefined) {
      obj.boundaryModel = ImplementBoundaryModel.toJSON(message.boundaryModel);
    }
    if (message.calibration !== undefined) {
      obj.calibration = ImplementCalibration.toJSON(message.calibration);
    }
    if (message.sensors !== undefined) {
      obj.sensors = ImplementSensors.toJSON(message.sensors);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Implement>, I>>(base?: I): Implement {
    return Implement.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Implement>, I>>(object: I): Implement {
    const message = createBaseImplement();
    message.id = object.id ?? "";
    message.customerId = object.customerId ?? "";
    message.customerUuid = object.customerUuid ?? "";
    message.dataModelVersion = object.dataModelVersion ?? 0;
    message.captureCompleted = object.captureCompleted ?? false;
    message.updatedAt = object.updatedAt ?? undefined;
    message.name = object.name ?? "";
    message.archetype = (object.archetype !== undefined && object.archetype !== null)
      ? ImplementArchetype.fromPartial(object.archetype)
      : undefined;
    message.hitchType = object.hitchType ?? undefined;
    message.ptoRequirements = (object.ptoRequirements !== undefined && object.ptoRequirements !== null)
      ? PtoRequirements.fromPartial(object.ptoRequirements)
      : undefined;
    message.scvInputs = (object.scvInputs !== undefined && object.scvInputs !== null)
      ? ScvInputs.fromPartial(object.scvInputs)
      : undefined;
    message.atim = object.atim ?? undefined;
    message.workingWidthM = object.workingWidthM ?? undefined;
    message.workingWidthMLeft = object.workingWidthMLeft ?? undefined;
    message.workingWidthMRight = object.workingWidthMRight ?? undefined;
    message.workingStartOffsetM = object.workingStartOffsetM ?? undefined;
    message.workingEndOffsetM = object.workingEndOffsetM ?? undefined;
    message.turnDirection = object.turnDirection ?? undefined;
    message.toolSpeedMS = object.toolSpeedMS ?? undefined;
    message.transitionSpeedMS = object.transitionSpeedMS ?? undefined;
    message.runUpDistanceM = object.runUpDistanceM ?? undefined;
    message.straightenDistanceM = object.straightenDistanceM ?? undefined;
    message.turningRadiusLimits =
      object.turningRadiusLimits?.map((e) => ImplementHeightTurningRadiusLimit.fromPartial(e)) || [];
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? Polygon2D.fromPartial(object.boundary)
      : undefined;
    message.boundaryModel = (object.boundaryModel !== undefined && object.boundaryModel !== null)
      ? ImplementBoundaryModel.fromPartial(object.boundaryModel)
      : undefined;
    message.calibration = (object.calibration !== undefined && object.calibration !== null)
      ? ImplementCalibration.fromPartial(object.calibration)
      : undefined;
    message.sensors = (object.sensors !== undefined && object.sensors !== null)
      ? ImplementSensors.fromPartial(object.sensors)
      : undefined;
    return message;
  },
};

function createBaseScvConnection(): ScvConnection {
  return { id: "", tractorScvOutputId: "", implementScvInputId: "" };
}

export const ScvConnection: MessageFns<ScvConnection> = {
  encode(message: ScvConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.tractorScvOutputId !== "") {
      writer.uint32(18).string(message.tractorScvOutputId);
    }
    if (message.implementScvInputId !== "") {
      writer.uint32(26).string(message.implementScvInputId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tractorScvOutputId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.implementScvInputId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvConnection {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      tractorScvOutputId: isSet(object.tractorScvOutputId)
        ? globalThis.String(object.tractorScvOutputId)
        : isSet(object.tractor_scv_output_id)
        ? globalThis.String(object.tractor_scv_output_id)
        : "",
      implementScvInputId: isSet(object.implementScvInputId)
        ? globalThis.String(object.implementScvInputId)
        : isSet(object.implement_scv_input_id)
        ? globalThis.String(object.implement_scv_input_id)
        : "",
    };
  },

  toJSON(message: ScvConnection): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.tractorScvOutputId !== "") {
      obj.tractorScvOutputId = message.tractorScvOutputId;
    }
    if (message.implementScvInputId !== "") {
      obj.implementScvInputId = message.implementScvInputId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvConnection>, I>>(base?: I): ScvConnection {
    return ScvConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvConnection>, I>>(object: I): ScvConnection {
    const message = createBaseScvConnection();
    message.id = object.id ?? "";
    message.tractorScvOutputId = object.tractorScvOutputId ?? "";
    message.implementScvInputId = object.implementScvInputId ?? "";
    return message;
  },
};

function createBaseScvInputs(): ScvInputs {
  return { inputs: [] };
}

export const ScvInputs: MessageFns<ScvInputs> = {
  encode(message: ScvInputs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.inputs) {
      ScvInput.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvInputs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvInputs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.inputs.push(ScvInput.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvInputs {
    return {
      inputs: globalThis.Array.isArray(object?.inputs) ? object.inputs.map((e: any) => ScvInput.fromJSON(e)) : [],
    };
  },

  toJSON(message: ScvInputs): unknown {
    const obj: any = {};
    if (message.inputs?.length) {
      obj.inputs = message.inputs.map((e) => ScvInput.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvInputs>, I>>(base?: I): ScvInputs {
    return ScvInputs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvInputs>, I>>(object: I): ScvInputs {
    const message = createBaseScvInputs();
    message.inputs = object.inputs?.map((e) => ScvInput.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScvInput(): ScvInput {
  return { id: "", function: "", recommendedPort: "", couplerDiameterMm: 0, coupler: 0, isHydraulicTopLink: false };
}

export const ScvInput: MessageFns<ScvInput> = {
  encode(message: ScvInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.function !== "") {
      writer.uint32(18).string(message.function);
    }
    if (message.recommendedPort !== "") {
      writer.uint32(26).string(message.recommendedPort);
    }
    if (message.couplerDiameterMm !== 0) {
      writer.uint32(89).double(message.couplerDiameterMm);
    }
    if (message.coupler !== 0) {
      writer.uint32(96).int32(message.coupler);
    }
    if (message.isHydraulicTopLink !== false) {
      writer.uint32(104).bool(message.isHydraulicTopLink);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.function = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recommendedPort = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.couplerDiameterMm = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.coupler = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isHydraulicTopLink = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvInput {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      function: isSet(object.function) ? globalThis.String(object.function) : "",
      recommendedPort: isSet(object.recommendedPort)
        ? globalThis.String(object.recommendedPort)
        : isSet(object.recommended_port)
        ? globalThis.String(object.recommended_port)
        : "",
      couplerDiameterMm: isSet(object.couplerDiameterMm)
        ? globalThis.Number(object.couplerDiameterMm)
        : isSet(object.coupler_diameter_mm)
        ? globalThis.Number(object.coupler_diameter_mm)
        : 0,
      coupler: isSet(object.coupler) ? hydraulicCouplerTypeFromJSON(object.coupler) : 0,
      isHydraulicTopLink: isSet(object.isHydraulicTopLink)
        ? globalThis.Boolean(object.isHydraulicTopLink)
        : isSet(object.is_hydraulic_top_link)
        ? globalThis.Boolean(object.is_hydraulic_top_link)
        : false,
    };
  },

  toJSON(message: ScvInput): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.function !== "") {
      obj.function = message.function;
    }
    if (message.recommendedPort !== "") {
      obj.recommendedPort = message.recommendedPort;
    }
    if (message.couplerDiameterMm !== 0) {
      obj.couplerDiameterMm = message.couplerDiameterMm;
    }
    if (message.coupler !== 0) {
      obj.coupler = hydraulicCouplerTypeToJSON(message.coupler);
    }
    if (message.isHydraulicTopLink !== false) {
      obj.isHydraulicTopLink = message.isHydraulicTopLink;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvInput>, I>>(base?: I): ScvInput {
    return ScvInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvInput>, I>>(object: I): ScvInput {
    const message = createBaseScvInput();
    message.id = object.id ?? "";
    message.function = object.function ?? "";
    message.recommendedPort = object.recommendedPort ?? "";
    message.couplerDiameterMm = object.couplerDiameterMm ?? 0;
    message.coupler = object.coupler ?? 0;
    message.isHydraulicTopLink = object.isHydraulicTopLink ?? false;
    return message;
  },
};

function createBaseScvOutputs(): ScvOutputs {
  return { scvOutput: [] };
}

export const ScvOutputs: MessageFns<ScvOutputs> = {
  encode(message: ScvOutputs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.scvOutput) {
      ScvOutput.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvOutputs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvOutputs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scvOutput.push(ScvOutput.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvOutputs {
    return {
      scvOutput: globalThis.Array.isArray(object?.scvOutput)
        ? object.scvOutput.map((e: any) => ScvOutput.fromJSON(e))
        : globalThis.Array.isArray(object?.scv_output)
        ? object.scv_output.map((e: any) => ScvOutput.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScvOutputs): unknown {
    const obj: any = {};
    if (message.scvOutput?.length) {
      obj.scvOutput = message.scvOutput.map((e) => ScvOutput.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvOutputs>, I>>(base?: I): ScvOutputs {
    return ScvOutputs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvOutputs>, I>>(object: I): ScvOutputs {
    const message = createBaseScvOutputs();
    message.scvOutput = object.scvOutput?.map((e) => ScvOutput.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScvOutput(): ScvOutput {
  return { id: "", port: 0, description: "", couplerDiameterMm: 0, coupler: 0, disabled: false };
}

export const ScvOutput: MessageFns<ScvOutput> = {
  encode(message: ScvOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.port !== 0) {
      writer.uint32(16).int32(message.port);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.couplerDiameterMm !== 0) {
      writer.uint32(33).double(message.couplerDiameterMm);
    }
    if (message.coupler !== 0) {
      writer.uint32(72).int32(message.coupler);
    }
    if (message.disabled !== false) {
      writer.uint32(64).bool(message.disabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.port = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.couplerDiameterMm = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.coupler = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvOutput {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      couplerDiameterMm: isSet(object.couplerDiameterMm)
        ? globalThis.Number(object.couplerDiameterMm)
        : isSet(object.coupler_diameter_mm)
        ? globalThis.Number(object.coupler_diameter_mm)
        : 0,
      coupler: isSet(object.coupler) ? hydraulicCouplerTypeFromJSON(object.coupler) : 0,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
    };
  },

  toJSON(message: ScvOutput): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.couplerDiameterMm !== 0) {
      obj.couplerDiameterMm = message.couplerDiameterMm;
    }
    if (message.coupler !== 0) {
      obj.coupler = hydraulicCouplerTypeToJSON(message.coupler);
    }
    if (message.disabled !== false) {
      obj.disabled = message.disabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvOutput>, I>>(base?: I): ScvOutput {
    return ScvOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvOutput>, I>>(object: I): ScvOutput {
    const message = createBaseScvOutput();
    message.id = object.id ?? "";
    message.port = object.port ?? 0;
    message.description = object.description ?? "";
    message.couplerDiameterMm = object.couplerDiameterMm ?? 0;
    message.coupler = object.coupler ?? 0;
    message.disabled = object.disabled ?? false;
    return message;
  },
};

function createBaseTractorHitch(): TractorHitch {
  return { type: 0, offsetYM: 0 };
}

export const TractorHitch: MessageFns<TractorHitch> = {
  encode(message: TractorHitch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.offsetYM !== 0) {
      writer.uint32(17).double(message.offsetYM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorHitch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorHitch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.offsetYM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorHitch {
    return {
      type: isSet(object.type) ? hitchTypeFromJSON(object.type) : 0,
      offsetYM: isSet(object.offsetYM)
        ? globalThis.Number(object.offsetYM)
        : isSet(object.offset_y_m)
        ? globalThis.Number(object.offset_y_m)
        : 0,
    };
  },

  toJSON(message: TractorHitch): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = hitchTypeToJSON(message.type);
    }
    if (message.offsetYM !== 0) {
      obj.offsetYM = message.offsetYM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorHitch>, I>>(base?: I): TractorHitch {
    return TractorHitch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorHitch>, I>>(object: I): TractorHitch {
    const message = createBaseTractorHitch();
    message.type = object.type ?? 0;
    message.offsetYM = object.offsetYM ?? 0;
    return message;
  },
};

function createBasePtoConfig(): PtoConfig {
  return { disabled: false, availableSpeeds: [] };
}

export const PtoConfig: MessageFns<PtoConfig> = {
  encode(message: PtoConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.disabled !== false) {
      writer.uint32(8).bool(message.disabled);
    }
    writer.uint32(18).fork();
    for (const v of message.availableSpeeds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PtoConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePtoConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.availableSpeeds.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.availableSpeeds.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PtoConfig {
    return {
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
      availableSpeeds: globalThis.Array.isArray(object?.availableSpeeds)
        ? object.availableSpeeds.map((e: any) => ptoSpeedFromJSON(e))
        : globalThis.Array.isArray(object?.available_speeds)
        ? object.available_speeds.map((e: any) => ptoSpeedFromJSON(e))
        : [],
    };
  },

  toJSON(message: PtoConfig): unknown {
    const obj: any = {};
    if (message.disabled !== false) {
      obj.disabled = message.disabled;
    }
    if (message.availableSpeeds?.length) {
      obj.availableSpeeds = message.availableSpeeds.map((e) => ptoSpeedToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PtoConfig>, I>>(base?: I): PtoConfig {
    return PtoConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PtoConfig>, I>>(object: I): PtoConfig {
    const message = createBasePtoConfig();
    message.disabled = object.disabled ?? false;
    message.availableSpeeds = object.availableSpeeds?.map((e) => e) || [];
    return message;
  },
};

function createBaseAutotractorSettings(): AutotractorSettings {
  return {
    controlSchemeOverride: undefined,
    maxSpeedMph: 0,
    maxSpeedSafetyBypassedMph: 0,
    differentialBrakingEnabled: false,
    maxSteeringAngleImplementEngaged: 0,
    hitchDownVal: 0,
  };
}

export const AutotractorSettings: MessageFns<AutotractorSettings> = {
  encode(message: AutotractorSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.controlSchemeOverride !== undefined) {
      writer.uint32(8).int32(message.controlSchemeOverride);
    }
    if (message.maxSpeedMph !== 0) {
      writer.uint32(17).double(message.maxSpeedMph);
    }
    if (message.maxSpeedSafetyBypassedMph !== 0) {
      writer.uint32(25).double(message.maxSpeedSafetyBypassedMph);
    }
    if (message.differentialBrakingEnabled !== false) {
      writer.uint32(32).bool(message.differentialBrakingEnabled);
    }
    if (message.maxSteeringAngleImplementEngaged !== 0) {
      writer.uint32(41).double(message.maxSteeringAngleImplementEngaged);
    }
    if (message.hitchDownVal !== 0) {
      writer.uint32(49).double(message.hitchDownVal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutotractorSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutotractorSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.controlSchemeOverride = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maxSpeedMph = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.maxSpeedSafetyBypassedMph = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.differentialBrakingEnabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.maxSteeringAngleImplementEngaged = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.hitchDownVal = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AutotractorSettings {
    return {
      controlSchemeOverride: isSet(object.controlSchemeOverride)
        ? controlSchemeFromJSON(object.controlSchemeOverride)
        : isSet(object.control_scheme_override)
        ? controlSchemeFromJSON(object.control_scheme_override)
        : undefined,
      maxSpeedMph: isSet(object.maxSpeedMph)
        ? globalThis.Number(object.maxSpeedMph)
        : isSet(object.max_speed_mph)
        ? globalThis.Number(object.max_speed_mph)
        : 0,
      maxSpeedSafetyBypassedMph: isSet(object.maxSpeedSafetyBypassedMph)
        ? globalThis.Number(object.maxSpeedSafetyBypassedMph)
        : isSet(object.max_speed_safety_bypassed_mph)
        ? globalThis.Number(object.max_speed_safety_bypassed_mph)
        : 0,
      differentialBrakingEnabled: isSet(object.differentialBrakingEnabled)
        ? globalThis.Boolean(object.differentialBrakingEnabled)
        : isSet(object.differential_braking_enabled)
        ? globalThis.Boolean(object.differential_braking_enabled)
        : false,
      maxSteeringAngleImplementEngaged: isSet(object.maxSteeringAngleImplementEngaged)
        ? globalThis.Number(object.maxSteeringAngleImplementEngaged)
        : isSet(object.max_steering_angle_implement_engaged)
        ? globalThis.Number(object.max_steering_angle_implement_engaged)
        : 0,
      hitchDownVal: isSet(object.hitchDownVal)
        ? globalThis.Number(object.hitchDownVal)
        : isSet(object.hitch_down_val)
        ? globalThis.Number(object.hitch_down_val)
        : 0,
    };
  },

  toJSON(message: AutotractorSettings): unknown {
    const obj: any = {};
    if (message.controlSchemeOverride !== undefined) {
      obj.controlSchemeOverride = controlSchemeToJSON(message.controlSchemeOverride);
    }
    if (message.maxSpeedMph !== 0) {
      obj.maxSpeedMph = message.maxSpeedMph;
    }
    if (message.maxSpeedSafetyBypassedMph !== 0) {
      obj.maxSpeedSafetyBypassedMph = message.maxSpeedSafetyBypassedMph;
    }
    if (message.differentialBrakingEnabled !== false) {
      obj.differentialBrakingEnabled = message.differentialBrakingEnabled;
    }
    if (message.maxSteeringAngleImplementEngaged !== 0) {
      obj.maxSteeringAngleImplementEngaged = message.maxSteeringAngleImplementEngaged;
    }
    if (message.hitchDownVal !== 0) {
      obj.hitchDownVal = message.hitchDownVal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AutotractorSettings>, I>>(base?: I): AutotractorSettings {
    return AutotractorSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutotractorSettings>, I>>(object: I): AutotractorSettings {
    const message = createBaseAutotractorSettings();
    message.controlSchemeOverride = object.controlSchemeOverride ?? undefined;
    message.maxSpeedMph = object.maxSpeedMph ?? 0;
    message.maxSpeedSafetyBypassedMph = object.maxSpeedSafetyBypassedMph ?? 0;
    message.differentialBrakingEnabled = object.differentialBrakingEnabled ?? false;
    message.maxSteeringAngleImplementEngaged = object.maxSteeringAngleImplementEngaged ?? 0;
    message.hitchDownVal = object.hitchDownVal ?? 0;
    return message;
  },
};

function createBaseSensor(): Sensor {
  return { port: 0, pctConversion: undefined, scvConnectionId: undefined };
}

export const Sensor: MessageFns<Sensor> = {
  encode(message: Sensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.port !== 0) {
      writer.uint32(8).uint32(message.port);
    }
    if (message.pctConversion !== undefined) {
      LinearPctConversion.encode(message.pctConversion, writer.uint32(18).fork()).join();
    }
    if (message.scvConnectionId !== undefined) {
      writer.uint32(26).string(message.scvConnectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Sensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.port = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pctConversion = LinearPctConversion.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scvConnectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sensor {
    return {
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      pctConversion: isSet(object.pctConversion)
        ? LinearPctConversion.fromJSON(object.pctConversion)
        : isSet(object.pct_conversion)
        ? LinearPctConversion.fromJSON(object.pct_conversion)
        : undefined,
      scvConnectionId: isSet(object.scvConnectionId)
        ? globalThis.String(object.scvConnectionId)
        : isSet(object.scv_connection_id)
        ? globalThis.String(object.scv_connection_id)
        : undefined,
    };
  },

  toJSON(message: Sensor): unknown {
    const obj: any = {};
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.pctConversion !== undefined) {
      obj.pctConversion = LinearPctConversion.toJSON(message.pctConversion);
    }
    if (message.scvConnectionId !== undefined) {
      obj.scvConnectionId = message.scvConnectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sensor>, I>>(base?: I): Sensor {
    return Sensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sensor>, I>>(object: I): Sensor {
    const message = createBaseSensor();
    message.port = object.port ?? 0;
    message.pctConversion = (object.pctConversion !== undefined && object.pctConversion !== null)
      ? LinearPctConversion.fromPartial(object.pctConversion)
      : undefined;
    message.scvConnectionId = object.scvConnectionId ?? undefined;
    return message;
  },
};

function createBaseSensorConfig(): SensorConfig {
  return { sensors: [] };
}

export const SensorConfig: MessageFns<SensorConfig> = {
  encode(message: SensorConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sensors) {
      Sensor.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SensorConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSensorConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sensors.push(Sensor.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SensorConfig {
    return {
      sensors: globalThis.Array.isArray(object?.sensors) ? object.sensors.map((e: any) => Sensor.fromJSON(e)) : [],
    };
  },

  toJSON(message: SensorConfig): unknown {
    const obj: any = {};
    if (message.sensors?.length) {
      obj.sensors = message.sensors.map((e) => Sensor.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SensorConfig>, I>>(base?: I): SensorConfig {
    return SensorConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SensorConfig>, I>>(object: I): SensorConfig {
    const message = createBaseSensorConfig();
    message.sensors = object.sensors?.map((e) => Sensor.fromPartial(e)) || [];
    return message;
  },
};

function createBaseImplementControlSchema(): ImplementControlSchema {
  return {
    liftLowerControls: undefined,
    ioConfig: undefined,
    ioLinkCfg: undefined,
    sensors: undefined,
    scvAutonomy: undefined,
    activities: undefined,
  };
}

export const ImplementControlSchema: MessageFns<ImplementControlSchema> = {
  encode(message: ImplementControlSchema, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.liftLowerControls !== undefined) {
      LiftLowerControls.encode(message.liftLowerControls, writer.uint32(10).fork()).join();
    }
    if (message.ioConfig !== undefined) {
      ImplementIOConfiguration.encode(message.ioConfig, writer.uint32(18).fork()).join();
    }
    if (message.ioLinkCfg !== undefined) {
      IOLinkConfig.encode(message.ioLinkCfg, writer.uint32(26).fork()).join();
    }
    if (message.sensors !== undefined) {
      SensorConfig.encode(message.sensors, writer.uint32(50).fork()).join();
    }
    if (message.scvAutonomy !== undefined) {
      ScvAutonomyConfiguration.encode(message.scvAutonomy, writer.uint32(34).fork()).join();
    }
    if (message.activities !== undefined) {
      RigActivitiesConfiguration.encode(message.activities, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementControlSchema {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementControlSchema();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.liftLowerControls = LiftLowerControls.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ioConfig = ImplementIOConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ioLinkCfg = IOLinkConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sensors = SensorConfig.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scvAutonomy = ScvAutonomyConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.activities = RigActivitiesConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementControlSchema {
    return {
      liftLowerControls: isSet(object.liftLowerControls)
        ? LiftLowerControls.fromJSON(object.liftLowerControls)
        : isSet(object.lift_lower_controls)
        ? LiftLowerControls.fromJSON(object.lift_lower_controls)
        : undefined,
      ioConfig: isSet(object.ioConfig)
        ? ImplementIOConfiguration.fromJSON(object.ioConfig)
        : isSet(object.io_config)
        ? ImplementIOConfiguration.fromJSON(object.io_config)
        : undefined,
      ioLinkCfg: isSet(object.ioLinkCfg)
        ? IOLinkConfig.fromJSON(object.ioLinkCfg)
        : isSet(object.io_link_cfg)
        ? IOLinkConfig.fromJSON(object.io_link_cfg)
        : undefined,
      sensors: isSet(object.sensors) ? SensorConfig.fromJSON(object.sensors) : undefined,
      scvAutonomy: isSet(object.scvAutonomy)
        ? ScvAutonomyConfiguration.fromJSON(object.scvAutonomy)
        : isSet(object.scv_autonomy)
        ? ScvAutonomyConfiguration.fromJSON(object.scv_autonomy)
        : undefined,
      activities: isSet(object.activities) ? RigActivitiesConfiguration.fromJSON(object.activities) : undefined,
    };
  },

  toJSON(message: ImplementControlSchema): unknown {
    const obj: any = {};
    if (message.liftLowerControls !== undefined) {
      obj.liftLowerControls = LiftLowerControls.toJSON(message.liftLowerControls);
    }
    if (message.ioConfig !== undefined) {
      obj.ioConfig = ImplementIOConfiguration.toJSON(message.ioConfig);
    }
    if (message.ioLinkCfg !== undefined) {
      obj.ioLinkCfg = IOLinkConfig.toJSON(message.ioLinkCfg);
    }
    if (message.sensors !== undefined) {
      obj.sensors = SensorConfig.toJSON(message.sensors);
    }
    if (message.scvAutonomy !== undefined) {
      obj.scvAutonomy = ScvAutonomyConfiguration.toJSON(message.scvAutonomy);
    }
    if (message.activities !== undefined) {
      obj.activities = RigActivitiesConfiguration.toJSON(message.activities);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementControlSchema>, I>>(base?: I): ImplementControlSchema {
    return ImplementControlSchema.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementControlSchema>, I>>(object: I): ImplementControlSchema {
    const message = createBaseImplementControlSchema();
    message.liftLowerControls = (object.liftLowerControls !== undefined && object.liftLowerControls !== null)
      ? LiftLowerControls.fromPartial(object.liftLowerControls)
      : undefined;
    message.ioConfig = (object.ioConfig !== undefined && object.ioConfig !== null)
      ? ImplementIOConfiguration.fromPartial(object.ioConfig)
      : undefined;
    message.ioLinkCfg = (object.ioLinkCfg !== undefined && object.ioLinkCfg !== null)
      ? IOLinkConfig.fromPartial(object.ioLinkCfg)
      : undefined;
    message.sensors = (object.sensors !== undefined && object.sensors !== null)
      ? SensorConfig.fromPartial(object.sensors)
      : undefined;
    message.scvAutonomy = (object.scvAutonomy !== undefined && object.scvAutonomy !== null)
      ? ScvAutonomyConfiguration.fromPartial(object.scvAutonomy)
      : undefined;
    message.activities = (object.activities !== undefined && object.activities !== null)
      ? RigActivitiesConfiguration.fromPartial(object.activities)
      : undefined;
    return message;
  },
};

function createBaseLiftLowerControls(): LiftLowerControls {
  return { maxLiftTimeMs: 0, maxLowerTimeMs: 0, none: undefined, threePoint: undefined };
}

export const LiftLowerControls: MessageFns<LiftLowerControls> = {
  encode(message: LiftLowerControls, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxLiftTimeMs !== 0) {
      writer.uint32(8).uint32(message.maxLiftTimeMs);
    }
    if (message.maxLowerTimeMs !== 0) {
      writer.uint32(16).uint32(message.maxLowerTimeMs);
    }
    if (message.none !== undefined) {
      Empty.encode(message.none, writer.uint32(26).fork()).join();
    }
    if (message.threePoint !== undefined) {
      ThreePointControls.encode(message.threePoint, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiftLowerControls {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiftLowerControls();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.maxLiftTimeMs = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxLowerTimeMs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.none = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.threePoint = ThreePointControls.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiftLowerControls {
    return {
      maxLiftTimeMs: isSet(object.maxLiftTimeMs)
        ? globalThis.Number(object.maxLiftTimeMs)
        : isSet(object.max_lift_time_ms)
        ? globalThis.Number(object.max_lift_time_ms)
        : 0,
      maxLowerTimeMs: isSet(object.maxLowerTimeMs)
        ? globalThis.Number(object.maxLowerTimeMs)
        : isSet(object.max_lower_time_ms)
        ? globalThis.Number(object.max_lower_time_ms)
        : 0,
      none: isSet(object.none) ? Empty.fromJSON(object.none) : undefined,
      threePoint: isSet(object.threePoint)
        ? ThreePointControls.fromJSON(object.threePoint)
        : isSet(object.three_point)
        ? ThreePointControls.fromJSON(object.three_point)
        : undefined,
    };
  },

  toJSON(message: LiftLowerControls): unknown {
    const obj: any = {};
    if (message.maxLiftTimeMs !== 0) {
      obj.maxLiftTimeMs = Math.round(message.maxLiftTimeMs);
    }
    if (message.maxLowerTimeMs !== 0) {
      obj.maxLowerTimeMs = Math.round(message.maxLowerTimeMs);
    }
    if (message.none !== undefined) {
      obj.none = Empty.toJSON(message.none);
    }
    if (message.threePoint !== undefined) {
      obj.threePoint = ThreePointControls.toJSON(message.threePoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiftLowerControls>, I>>(base?: I): LiftLowerControls {
    return LiftLowerControls.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiftLowerControls>, I>>(object: I): LiftLowerControls {
    const message = createBaseLiftLowerControls();
    message.maxLiftTimeMs = object.maxLiftTimeMs ?? 0;
    message.maxLowerTimeMs = object.maxLowerTimeMs ?? 0;
    message.none = (object.none !== undefined && object.none !== null) ? Empty.fromPartial(object.none) : undefined;
    message.threePoint = (object.threePoint !== undefined && object.threePoint !== null)
      ? ThreePointControls.fromPartial(object.threePoint)
      : undefined;
    return message;
  },
};

function createBaseImplementIOConfiguration(): ImplementIOConfiguration {
  return { relayConfig: undefined, inputConfig: undefined };
}

export const ImplementIOConfiguration: MessageFns<ImplementIOConfiguration> = {
  encode(message: ImplementIOConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.relayConfig !== undefined) {
      RelayConfiguration.encode(message.relayConfig, writer.uint32(10).fork()).join();
    }
    if (message.inputConfig !== undefined) {
      InputPinConfiguration.encode(message.inputConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementIOConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementIOConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.relayConfig = RelayConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inputConfig = InputPinConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementIOConfiguration {
    return {
      relayConfig: isSet(object.relayConfig)
        ? RelayConfiguration.fromJSON(object.relayConfig)
        : isSet(object.relay_config)
        ? RelayConfiguration.fromJSON(object.relay_config)
        : undefined,
      inputConfig: isSet(object.inputConfig)
        ? InputPinConfiguration.fromJSON(object.inputConfig)
        : isSet(object.input_config)
        ? InputPinConfiguration.fromJSON(object.input_config)
        : undefined,
    };
  },

  toJSON(message: ImplementIOConfiguration): unknown {
    const obj: any = {};
    if (message.relayConfig !== undefined) {
      obj.relayConfig = RelayConfiguration.toJSON(message.relayConfig);
    }
    if (message.inputConfig !== undefined) {
      obj.inputConfig = InputPinConfiguration.toJSON(message.inputConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementIOConfiguration>, I>>(base?: I): ImplementIOConfiguration {
    return ImplementIOConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementIOConfiguration>, I>>(object: I): ImplementIOConfiguration {
    const message = createBaseImplementIOConfiguration();
    message.relayConfig = (object.relayConfig !== undefined && object.relayConfig !== null)
      ? RelayConfiguration.fromPartial(object.relayConfig)
      : undefined;
    message.inputConfig = (object.inputConfig !== undefined && object.inputConfig !== null)
      ? InputPinConfiguration.fromPartial(object.inputConfig)
      : undefined;
    return message;
  },
};

function createBaseThreePointControls(): ThreePointControls {
  return { minRaisedValue: 0, maxLoweredValue: 0, toplinkScvOutputId: undefined };
}

export const ThreePointControls: MessageFns<ThreePointControls> = {
  encode(message: ThreePointControls, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minRaisedValue !== 0) {
      writer.uint32(13).float(message.minRaisedValue);
    }
    if (message.maxLoweredValue !== 0) {
      writer.uint32(21).float(message.maxLoweredValue);
    }
    if (message.toplinkScvOutputId !== undefined) {
      writer.uint32(26).string(message.toplinkScvOutputId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreePointControls {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreePointControls();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.minRaisedValue = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.maxLoweredValue = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.toplinkScvOutputId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreePointControls {
    return {
      minRaisedValue: isSet(object.minRaisedValue)
        ? globalThis.Number(object.minRaisedValue)
        : isSet(object.min_raised_value)
        ? globalThis.Number(object.min_raised_value)
        : 0,
      maxLoweredValue: isSet(object.maxLoweredValue)
        ? globalThis.Number(object.maxLoweredValue)
        : isSet(object.max_lowered_value)
        ? globalThis.Number(object.max_lowered_value)
        : 0,
      toplinkScvOutputId: isSet(object.toplinkScvOutputId)
        ? globalThis.String(object.toplinkScvOutputId)
        : isSet(object.toplink_scv_output_id)
        ? globalThis.String(object.toplink_scv_output_id)
        : undefined,
    };
  },

  toJSON(message: ThreePointControls): unknown {
    const obj: any = {};
    if (message.minRaisedValue !== 0) {
      obj.minRaisedValue = message.minRaisedValue;
    }
    if (message.maxLoweredValue !== 0) {
      obj.maxLoweredValue = message.maxLoweredValue;
    }
    if (message.toplinkScvOutputId !== undefined) {
      obj.toplinkScvOutputId = message.toplinkScvOutputId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThreePointControls>, I>>(base?: I): ThreePointControls {
    return ThreePointControls.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThreePointControls>, I>>(object: I): ThreePointControls {
    const message = createBaseThreePointControls();
    message.minRaisedValue = object.minRaisedValue ?? 0;
    message.maxLoweredValue = object.maxLoweredValue ?? 0;
    message.toplinkScvOutputId = object.toplinkScvOutputId ?? undefined;
    return message;
  },
};

function createBaseRelayConfiguration(): RelayConfiguration {
  return { hwV2Cfg: undefined };
}

export const RelayConfiguration: MessageFns<RelayConfiguration> = {
  encode(message: RelayConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hwV2Cfg !== undefined) {
      HWV2RelayConfiguration.encode(message.hwV2Cfg, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RelayConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRelayConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hwV2Cfg = HWV2RelayConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RelayConfiguration {
    return {
      hwV2Cfg: isSet(object.hwV2Cfg)
        ? HWV2RelayConfiguration.fromJSON(object.hwV2Cfg)
        : isSet(object.hw_v2_cfg)
        ? HWV2RelayConfiguration.fromJSON(object.hw_v2_cfg)
        : undefined,
    };
  },

  toJSON(message: RelayConfiguration): unknown {
    const obj: any = {};
    if (message.hwV2Cfg !== undefined) {
      obj.hwV2Cfg = HWV2RelayConfiguration.toJSON(message.hwV2Cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RelayConfiguration>, I>>(base?: I): RelayConfiguration {
    return RelayConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RelayConfiguration>, I>>(object: I): RelayConfiguration {
    const message = createBaseRelayConfiguration();
    message.hwV2Cfg = (object.hwV2Cfg !== undefined && object.hwV2Cfg !== null)
      ? HWV2RelayConfiguration.fromPartial(object.hwV2Cfg)
      : undefined;
    return message;
  },
};

function createBaseHWV2RelayConfiguration(): HWV2RelayConfiguration {
  return { estopConnected: false, momentaryEnableConnected: false, momentaryDisableConnected: false };
}

export const HWV2RelayConfiguration: MessageFns<HWV2RelayConfiguration> = {
  encode(message: HWV2RelayConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.estopConnected !== false) {
      writer.uint32(8).bool(message.estopConnected);
    }
    if (message.momentaryEnableConnected !== false) {
      writer.uint32(16).bool(message.momentaryEnableConnected);
    }
    if (message.momentaryDisableConnected !== false) {
      writer.uint32(24).bool(message.momentaryDisableConnected);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HWV2RelayConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHWV2RelayConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.estopConnected = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.momentaryEnableConnected = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.momentaryDisableConnected = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HWV2RelayConfiguration {
    return {
      estopConnected: isSet(object.estopConnected)
        ? globalThis.Boolean(object.estopConnected)
        : isSet(object.estop_connected)
        ? globalThis.Boolean(object.estop_connected)
        : false,
      momentaryEnableConnected: isSet(object.momentaryEnableConnected)
        ? globalThis.Boolean(object.momentaryEnableConnected)
        : isSet(object.momentary_enable_connected)
        ? globalThis.Boolean(object.momentary_enable_connected)
        : false,
      momentaryDisableConnected: isSet(object.momentaryDisableConnected)
        ? globalThis.Boolean(object.momentaryDisableConnected)
        : isSet(object.momentary_disable_connected)
        ? globalThis.Boolean(object.momentary_disable_connected)
        : false,
    };
  },

  toJSON(message: HWV2RelayConfiguration): unknown {
    const obj: any = {};
    if (message.estopConnected !== false) {
      obj.estopConnected = message.estopConnected;
    }
    if (message.momentaryEnableConnected !== false) {
      obj.momentaryEnableConnected = message.momentaryEnableConnected;
    }
    if (message.momentaryDisableConnected !== false) {
      obj.momentaryDisableConnected = message.momentaryDisableConnected;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HWV2RelayConfiguration>, I>>(base?: I): HWV2RelayConfiguration {
    return HWV2RelayConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HWV2RelayConfiguration>, I>>(object: I): HWV2RelayConfiguration {
    const message = createBaseHWV2RelayConfiguration();
    message.estopConnected = object.estopConnected ?? false;
    message.momentaryEnableConnected = object.momentaryEnableConnected ?? false;
    message.momentaryDisableConnected = object.momentaryDisableConnected ?? false;
    return message;
  },
};

function createBaseInputPinConfiguration(): InputPinConfiguration {
  return { hwV2Cfg: undefined };
}

export const InputPinConfiguration: MessageFns<InputPinConfiguration> = {
  encode(message: InputPinConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hwV2Cfg !== undefined) {
      HWV2InputPinConfiguration.encode(message.hwV2Cfg, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputPinConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputPinConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hwV2Cfg = HWV2InputPinConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputPinConfiguration {
    return {
      hwV2Cfg: isSet(object.hwV2Cfg)
        ? HWV2InputPinConfiguration.fromJSON(object.hwV2Cfg)
        : isSet(object.hw_v2_cfg)
        ? HWV2InputPinConfiguration.fromJSON(object.hw_v2_cfg)
        : undefined,
    };
  },

  toJSON(message: InputPinConfiguration): unknown {
    const obj: any = {};
    if (message.hwV2Cfg !== undefined) {
      obj.hwV2Cfg = HWV2InputPinConfiguration.toJSON(message.hwV2Cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InputPinConfiguration>, I>>(base?: I): InputPinConfiguration {
    return InputPinConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputPinConfiguration>, I>>(object: I): InputPinConfiguration {
    const message = createBaseInputPinConfiguration();
    message.hwV2Cfg = (object.hwV2Cfg !== undefined && object.hwV2Cfg !== null)
      ? HWV2InputPinConfiguration.fromPartial(object.hwV2Cfg)
      : undefined;
    return message;
  },
};

function createBaseHWV2InputPinConfiguration(): HWV2InputPinConfiguration {
  return {};
}

export const HWV2InputPinConfiguration: MessageFns<HWV2InputPinConfiguration> = {
  encode(_: HWV2InputPinConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HWV2InputPinConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHWV2InputPinConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): HWV2InputPinConfiguration {
    return {};
  },

  toJSON(_: HWV2InputPinConfiguration): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<HWV2InputPinConfiguration>, I>>(base?: I): HWV2InputPinConfiguration {
    return HWV2InputPinConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HWV2InputPinConfiguration>, I>>(_: I): HWV2InputPinConfiguration {
    const message = createBaseHWV2InputPinConfiguration();
    return message;
  },
};

function createBaseIOLinkConfig(): IOLinkConfig {
  return { ipAddress: "", modbusPort: 0, readRegisters: [] };
}

export const IOLinkConfig: MessageFns<IOLinkConfig> = {
  encode(message: IOLinkConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ipAddress !== "") {
      writer.uint32(10).string(message.ipAddress);
    }
    if (message.modbusPort !== 0) {
      writer.uint32(16).uint32(message.modbusPort);
    }
    for (const v of message.readRegisters) {
      IOLinkRegisterDevice.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IOLinkConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIOLinkConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.modbusPort = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.readRegisters.push(IOLinkRegisterDevice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IOLinkConfig {
    return {
      ipAddress: isSet(object.ipAddress)
        ? globalThis.String(object.ipAddress)
        : isSet(object.ip_address)
        ? globalThis.String(object.ip_address)
        : "",
      modbusPort: isSet(object.modbusPort)
        ? globalThis.Number(object.modbusPort)
        : isSet(object.modbus_port)
        ? globalThis.Number(object.modbus_port)
        : 0,
      readRegisters: globalThis.Array.isArray(object?.readRegisters)
        ? object.readRegisters.map((e: any) => IOLinkRegisterDevice.fromJSON(e))
        : globalThis.Array.isArray(object?.read_registers)
        ? object.read_registers.map((e: any) => IOLinkRegisterDevice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: IOLinkConfig): unknown {
    const obj: any = {};
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.modbusPort !== 0) {
      obj.modbusPort = Math.round(message.modbusPort);
    }
    if (message.readRegisters?.length) {
      obj.readRegisters = message.readRegisters.map((e) => IOLinkRegisterDevice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IOLinkConfig>, I>>(base?: I): IOLinkConfig {
    return IOLinkConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IOLinkConfig>, I>>(object: I): IOLinkConfig {
    const message = createBaseIOLinkConfig();
    message.ipAddress = object.ipAddress ?? "";
    message.modbusPort = object.modbusPort ?? 0;
    message.readRegisters = object.readRegisters?.map((e) => IOLinkRegisterDevice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseIOLinkRegisterDevice(): IOLinkRegisterDevice {
  return {
    name: "",
    id: "",
    address: 0,
    deviceId: 0,
    conversion: undefined,
    scvPosition: undefined,
    scvInputPosition: undefined,
    generic: undefined,
  };
}

export const IOLinkRegisterDevice: MessageFns<IOLinkRegisterDevice> = {
  encode(message: IOLinkRegisterDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== "") {
      writer.uint32(42).string(message.id);
    }
    if (message.address !== 0) {
      writer.uint32(16).uint32(message.address);
    }
    if (message.deviceId !== 0) {
      writer.uint32(24).uint32(message.deviceId);
    }
    if (message.conversion !== undefined) {
      DataTypeConversion.encode(message.conversion, writer.uint32(34).fork()).join();
    }
    if (message.scvPosition !== undefined) {
      IOLinkScvPositionSensor.encode(message.scvPosition, writer.uint32(50).fork()).join();
    }
    if (message.scvInputPosition !== undefined) {
      IOLinkScvInputPositionSensor.encode(message.scvInputPosition, writer.uint32(66).fork()).join();
    }
    if (message.generic !== undefined) {
      IOLinkGenericSensor.encode(message.generic, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IOLinkRegisterDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIOLinkRegisterDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.address = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.deviceId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.conversion = DataTypeConversion.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scvPosition = IOLinkScvPositionSensor.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.scvInputPosition = IOLinkScvInputPositionSensor.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.generic = IOLinkGenericSensor.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IOLinkRegisterDevice {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      address: isSet(object.address) ? globalThis.Number(object.address) : 0,
      deviceId: isSet(object.deviceId)
        ? globalThis.Number(object.deviceId)
        : isSet(object.device_id)
        ? globalThis.Number(object.device_id)
        : 0,
      conversion: isSet(object.conversion) ? DataTypeConversion.fromJSON(object.conversion) : undefined,
      scvPosition: isSet(object.scvPosition)
        ? IOLinkScvPositionSensor.fromJSON(object.scvPosition)
        : isSet(object.scv_position)
        ? IOLinkScvPositionSensor.fromJSON(object.scv_position)
        : undefined,
      scvInputPosition: isSet(object.scvInputPosition)
        ? IOLinkScvInputPositionSensor.fromJSON(object.scvInputPosition)
        : isSet(object.scv_input_position)
        ? IOLinkScvInputPositionSensor.fromJSON(object.scv_input_position)
        : undefined,
      generic: isSet(object.generic) ? IOLinkGenericSensor.fromJSON(object.generic) : undefined,
    };
  },

  toJSON(message: IOLinkRegisterDevice): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.address !== 0) {
      obj.address = Math.round(message.address);
    }
    if (message.deviceId !== 0) {
      obj.deviceId = Math.round(message.deviceId);
    }
    if (message.conversion !== undefined) {
      obj.conversion = DataTypeConversion.toJSON(message.conversion);
    }
    if (message.scvPosition !== undefined) {
      obj.scvPosition = IOLinkScvPositionSensor.toJSON(message.scvPosition);
    }
    if (message.scvInputPosition !== undefined) {
      obj.scvInputPosition = IOLinkScvInputPositionSensor.toJSON(message.scvInputPosition);
    }
    if (message.generic !== undefined) {
      obj.generic = IOLinkGenericSensor.toJSON(message.generic);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IOLinkRegisterDevice>, I>>(base?: I): IOLinkRegisterDevice {
    return IOLinkRegisterDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IOLinkRegisterDevice>, I>>(object: I): IOLinkRegisterDevice {
    const message = createBaseIOLinkRegisterDevice();
    message.name = object.name ?? "";
    message.id = object.id ?? "";
    message.address = object.address ?? 0;
    message.deviceId = object.deviceId ?? 0;
    message.conversion = (object.conversion !== undefined && object.conversion !== null)
      ? DataTypeConversion.fromPartial(object.conversion)
      : undefined;
    message.scvPosition = (object.scvPosition !== undefined && object.scvPosition !== null)
      ? IOLinkScvPositionSensor.fromPartial(object.scvPosition)
      : undefined;
    message.scvInputPosition = (object.scvInputPosition !== undefined && object.scvInputPosition !== null)
      ? IOLinkScvInputPositionSensor.fromPartial(object.scvInputPosition)
      : undefined;
    message.generic = (object.generic !== undefined && object.generic !== null)
      ? IOLinkGenericSensor.fromPartial(object.generic)
      : undefined;
    return message;
  },
};

function createBaseDataTypeConversion(): DataTypeConversion {
  return { linearPctConversion: undefined };
}

export const DataTypeConversion: MessageFns<DataTypeConversion> = {
  encode(message: DataTypeConversion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linearPctConversion !== undefined) {
      LinearPctConversion.encode(message.linearPctConversion, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataTypeConversion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataTypeConversion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linearPctConversion = LinearPctConversion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataTypeConversion {
    return {
      linearPctConversion: isSet(object.linearPctConversion)
        ? LinearPctConversion.fromJSON(object.linearPctConversion)
        : isSet(object.linear_pct_conversion)
        ? LinearPctConversion.fromJSON(object.linear_pct_conversion)
        : undefined,
    };
  },

  toJSON(message: DataTypeConversion): unknown {
    const obj: any = {};
    if (message.linearPctConversion !== undefined) {
      obj.linearPctConversion = LinearPctConversion.toJSON(message.linearPctConversion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataTypeConversion>, I>>(base?: I): DataTypeConversion {
    return DataTypeConversion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataTypeConversion>, I>>(object: I): DataTypeConversion {
    const message = createBaseDataTypeConversion();
    message.linearPctConversion = (object.linearPctConversion !== undefined && object.linearPctConversion !== null)
      ? LinearPctConversion.fromPartial(object.linearPctConversion)
      : undefined;
    return message;
  },
};

function createBaseLinearPctConversion(): LinearPctConversion {
  return { valAt0Pct: 0, valAt100Pct: 0 };
}

export const LinearPctConversion: MessageFns<LinearPctConversion> = {
  encode(message: LinearPctConversion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.valAt0Pct !== 0) {
      writer.uint32(13).float(message.valAt0Pct);
    }
    if (message.valAt100Pct !== 0) {
      writer.uint32(21).float(message.valAt100Pct);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LinearPctConversion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLinearPctConversion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.valAt0Pct = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.valAt100Pct = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LinearPctConversion {
    return {
      valAt0Pct: isSet(object.valAt0Pct)
        ? globalThis.Number(object.valAt0Pct)
        : isSet(object.val_at_0_pct)
        ? globalThis.Number(object.val_at_0_pct)
        : 0,
      valAt100Pct: isSet(object.valAt100Pct)
        ? globalThis.Number(object.valAt100Pct)
        : isSet(object.val_at_100_pct)
        ? globalThis.Number(object.val_at_100_pct)
        : 0,
    };
  },

  toJSON(message: LinearPctConversion): unknown {
    const obj: any = {};
    if (message.valAt0Pct !== 0) {
      obj.valAt0Pct = message.valAt0Pct;
    }
    if (message.valAt100Pct !== 0) {
      obj.valAt100Pct = message.valAt100Pct;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LinearPctConversion>, I>>(base?: I): LinearPctConversion {
    return LinearPctConversion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LinearPctConversion>, I>>(object: I): LinearPctConversion {
    const message = createBaseLinearPctConversion();
    message.valAt0Pct = object.valAt0Pct ?? 0;
    message.valAt100Pct = object.valAt100Pct ?? 0;
    return message;
  },
};

function createBaseIOLinkScvPositionSensor(): IOLinkScvPositionSensor {
  return { scvConnectionId: "" };
}

export const IOLinkScvPositionSensor: MessageFns<IOLinkScvPositionSensor> = {
  encode(message: IOLinkScvPositionSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scvConnectionId !== "") {
      writer.uint32(10).string(message.scvConnectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IOLinkScvPositionSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIOLinkScvPositionSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scvConnectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IOLinkScvPositionSensor {
    return {
      scvConnectionId: isSet(object.scvConnectionId)
        ? globalThis.String(object.scvConnectionId)
        : isSet(object.scv_connection_id)
        ? globalThis.String(object.scv_connection_id)
        : "",
    };
  },

  toJSON(message: IOLinkScvPositionSensor): unknown {
    const obj: any = {};
    if (message.scvConnectionId !== "") {
      obj.scvConnectionId = message.scvConnectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IOLinkScvPositionSensor>, I>>(base?: I): IOLinkScvPositionSensor {
    return IOLinkScvPositionSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IOLinkScvPositionSensor>, I>>(object: I): IOLinkScvPositionSensor {
    const message = createBaseIOLinkScvPositionSensor();
    message.scvConnectionId = object.scvConnectionId ?? "";
    return message;
  },
};

function createBaseIOLinkScvInputPositionSensor(): IOLinkScvInputPositionSensor {
  return { scvInputId: "" };
}

export const IOLinkScvInputPositionSensor: MessageFns<IOLinkScvInputPositionSensor> = {
  encode(message: IOLinkScvInputPositionSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scvInputId !== "") {
      writer.uint32(10).string(message.scvInputId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IOLinkScvInputPositionSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIOLinkScvInputPositionSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scvInputId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IOLinkScvInputPositionSensor {
    return {
      scvInputId: isSet(object.scvInputId)
        ? globalThis.String(object.scvInputId)
        : isSet(object.scv_input_id)
        ? globalThis.String(object.scv_input_id)
        : "",
    };
  },

  toJSON(message: IOLinkScvInputPositionSensor): unknown {
    const obj: any = {};
    if (message.scvInputId !== "") {
      obj.scvInputId = message.scvInputId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IOLinkScvInputPositionSensor>, I>>(base?: I): IOLinkScvInputPositionSensor {
    return IOLinkScvInputPositionSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IOLinkScvInputPositionSensor>, I>>(object: I): IOLinkScvInputPositionSensor {
    const message = createBaseIOLinkScvInputPositionSensor();
    message.scvInputId = object.scvInputId ?? "";
    return message;
  },
};

function createBaseIOLinkGenericSensor(): IOLinkGenericSensor {
  return { name: "" };
}

export const IOLinkGenericSensor: MessageFns<IOLinkGenericSensor> = {
  encode(message: IOLinkGenericSensor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IOLinkGenericSensor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIOLinkGenericSensor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IOLinkGenericSensor {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: IOLinkGenericSensor): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IOLinkGenericSensor>, I>>(base?: I): IOLinkGenericSensor {
    return IOLinkGenericSensor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IOLinkGenericSensor>, I>>(object: I): IOLinkGenericSensor {
    const message = createBaseIOLinkGenericSensor();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseThreePointAutonomyControlConfiguration(): ThreePointAutonomyControlConfiguration {
  return {
    holdTargetHeight: undefined,
    holdFloat: undefined,
    holdNone: undefined,
    entryGoToTargetHeight: undefined,
    entryDetentUp: undefined,
    entryDetentDown: undefined,
    entryNone: undefined,
  };
}

export const ThreePointAutonomyControlConfiguration: MessageFns<ThreePointAutonomyControlConfiguration> = {
  encode(message: ThreePointAutonomyControlConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.holdTargetHeight !== undefined) {
      writer.uint32(13).float(message.holdTargetHeight);
    }
    if (message.holdFloat !== undefined) {
      Empty.encode(message.holdFloat, writer.uint32(18).fork()).join();
    }
    if (message.holdNone !== undefined) {
      Empty.encode(message.holdNone, writer.uint32(26).fork()).join();
    }
    if (message.entryGoToTargetHeight !== undefined) {
      writer.uint32(37).float(message.entryGoToTargetHeight);
    }
    if (message.entryDetentUp !== undefined) {
      Empty.encode(message.entryDetentUp, writer.uint32(42).fork()).join();
    }
    if (message.entryDetentDown !== undefined) {
      Empty.encode(message.entryDetentDown, writer.uint32(50).fork()).join();
    }
    if (message.entryNone !== undefined) {
      Empty.encode(message.entryNone, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreePointAutonomyControlConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreePointAutonomyControlConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.holdTargetHeight = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.holdFloat = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.holdNone = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.entryGoToTargetHeight = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.entryDetentUp = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.entryDetentDown = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.entryNone = Empty.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreePointAutonomyControlConfiguration {
    return {
      holdTargetHeight: isSet(object.holdTargetHeight)
        ? globalThis.Number(object.holdTargetHeight)
        : isSet(object.hold_target_height)
        ? globalThis.Number(object.hold_target_height)
        : undefined,
      holdFloat: isSet(object.holdFloat)
        ? Empty.fromJSON(object.holdFloat)
        : isSet(object.hold_float)
        ? Empty.fromJSON(object.hold_float)
        : undefined,
      holdNone: isSet(object.holdNone)
        ? Empty.fromJSON(object.holdNone)
        : isSet(object.hold_none)
        ? Empty.fromJSON(object.hold_none)
        : undefined,
      entryGoToTargetHeight: isSet(object.entryGoToTargetHeight)
        ? globalThis.Number(object.entryGoToTargetHeight)
        : isSet(object.entry_go_to_target_height)
        ? globalThis.Number(object.entry_go_to_target_height)
        : undefined,
      entryDetentUp: isSet(object.entryDetentUp)
        ? Empty.fromJSON(object.entryDetentUp)
        : isSet(object.entry_detent_up)
        ? Empty.fromJSON(object.entry_detent_up)
        : undefined,
      entryDetentDown: isSet(object.entryDetentDown)
        ? Empty.fromJSON(object.entryDetentDown)
        : isSet(object.entry_detent_down)
        ? Empty.fromJSON(object.entry_detent_down)
        : undefined,
      entryNone: isSet(object.entryNone)
        ? Empty.fromJSON(object.entryNone)
        : isSet(object.entry_none)
        ? Empty.fromJSON(object.entry_none)
        : undefined,
    };
  },

  toJSON(message: ThreePointAutonomyControlConfiguration): unknown {
    const obj: any = {};
    if (message.holdTargetHeight !== undefined) {
      obj.holdTargetHeight = message.holdTargetHeight;
    }
    if (message.holdFloat !== undefined) {
      obj.holdFloat = Empty.toJSON(message.holdFloat);
    }
    if (message.holdNone !== undefined) {
      obj.holdNone = Empty.toJSON(message.holdNone);
    }
    if (message.entryGoToTargetHeight !== undefined) {
      obj.entryGoToTargetHeight = message.entryGoToTargetHeight;
    }
    if (message.entryDetentUp !== undefined) {
      obj.entryDetentUp = Empty.toJSON(message.entryDetentUp);
    }
    if (message.entryDetentDown !== undefined) {
      obj.entryDetentDown = Empty.toJSON(message.entryDetentDown);
    }
    if (message.entryNone !== undefined) {
      obj.entryNone = Empty.toJSON(message.entryNone);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThreePointAutonomyControlConfiguration>, I>>(
    base?: I,
  ): ThreePointAutonomyControlConfiguration {
    return ThreePointAutonomyControlConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThreePointAutonomyControlConfiguration>, I>>(
    object: I,
  ): ThreePointAutonomyControlConfiguration {
    const message = createBaseThreePointAutonomyControlConfiguration();
    message.holdTargetHeight = object.holdTargetHeight ?? undefined;
    message.holdFloat = (object.holdFloat !== undefined && object.holdFloat !== null)
      ? Empty.fromPartial(object.holdFloat)
      : undefined;
    message.holdNone = (object.holdNone !== undefined && object.holdNone !== null)
      ? Empty.fromPartial(object.holdNone)
      : undefined;
    message.entryGoToTargetHeight = object.entryGoToTargetHeight ?? undefined;
    message.entryDetentUp = (object.entryDetentUp !== undefined && object.entryDetentUp !== null)
      ? Empty.fromPartial(object.entryDetentUp)
      : undefined;
    message.entryDetentDown = (object.entryDetentDown !== undefined && object.entryDetentDown !== null)
      ? Empty.fromPartial(object.entryDetentDown)
      : undefined;
    message.entryNone = (object.entryNone !== undefined && object.entryNone !== null)
      ? Empty.fromPartial(object.entryNone)
      : undefined;
    return message;
  },
};

function createBaseScvAutonomyConfiguration(): ScvAutonomyConfiguration {
  return {
    heightScvConnectionId: undefined,
    aux1ScvConnectionId: undefined,
    aux2ScvConnectionId: undefined,
    activities: undefined,
  };
}

export const ScvAutonomyConfiguration: MessageFns<ScvAutonomyConfiguration> = {
  encode(message: ScvAutonomyConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.heightScvConnectionId !== undefined) {
      writer.uint32(10).string(message.heightScvConnectionId);
    }
    if (message.aux1ScvConnectionId !== undefined) {
      writer.uint32(18).string(message.aux1ScvConnectionId);
    }
    if (message.aux2ScvConnectionId !== undefined) {
      writer.uint32(26).string(message.aux2ScvConnectionId);
    }
    if (message.activities !== undefined) {
      ScvAutonomyActivitiesConfiguration.encode(message.activities, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvAutonomyConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvAutonomyConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.heightScvConnectionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.aux1ScvConnectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.aux2ScvConnectionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.activities = ScvAutonomyActivitiesConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvAutonomyConfiguration {
    return {
      heightScvConnectionId: isSet(object.heightScvConnectionId)
        ? globalThis.String(object.heightScvConnectionId)
        : isSet(object.height_scv_connection_id)
        ? globalThis.String(object.height_scv_connection_id)
        : undefined,
      aux1ScvConnectionId: isSet(object.aux1ScvConnectionId)
        ? globalThis.String(object.aux1ScvConnectionId)
        : isSet(object.aux1_scv_connection_id)
        ? globalThis.String(object.aux1_scv_connection_id)
        : undefined,
      aux2ScvConnectionId: isSet(object.aux2ScvConnectionId)
        ? globalThis.String(object.aux2ScvConnectionId)
        : isSet(object.aux2_scv_connection_id)
        ? globalThis.String(object.aux2_scv_connection_id)
        : undefined,
      activities: isSet(object.activities) ? ScvAutonomyActivitiesConfiguration.fromJSON(object.activities) : undefined,
    };
  },

  toJSON(message: ScvAutonomyConfiguration): unknown {
    const obj: any = {};
    if (message.heightScvConnectionId !== undefined) {
      obj.heightScvConnectionId = message.heightScvConnectionId;
    }
    if (message.aux1ScvConnectionId !== undefined) {
      obj.aux1ScvConnectionId = message.aux1ScvConnectionId;
    }
    if (message.aux2ScvConnectionId !== undefined) {
      obj.aux2ScvConnectionId = message.aux2ScvConnectionId;
    }
    if (message.activities !== undefined) {
      obj.activities = ScvAutonomyActivitiesConfiguration.toJSON(message.activities);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvAutonomyConfiguration>, I>>(base?: I): ScvAutonomyConfiguration {
    return ScvAutonomyConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvAutonomyConfiguration>, I>>(object: I): ScvAutonomyConfiguration {
    const message = createBaseScvAutonomyConfiguration();
    message.heightScvConnectionId = object.heightScvConnectionId ?? undefined;
    message.aux1ScvConnectionId = object.aux1ScvConnectionId ?? undefined;
    message.aux2ScvConnectionId = object.aux2ScvConnectionId ?? undefined;
    message.activities = (object.activities !== undefined && object.activities !== null)
      ? ScvAutonomyActivitiesConfiguration.fromPartial(object.activities)
      : undefined;
    return message;
  },
};

function createBaseScvAutonomyActivitiesConfiguration(): ScvAutonomyActivitiesConfiguration {
  return { activities: [] };
}

export const ScvAutonomyActivitiesConfiguration: MessageFns<ScvAutonomyActivitiesConfiguration> = {
  encode(message: ScvAutonomyActivitiesConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.activities) {
      ScvAutonomyActivityConfiguration.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvAutonomyActivitiesConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvAutonomyActivitiesConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.activities.push(ScvAutonomyActivityConfiguration.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvAutonomyActivitiesConfiguration {
    return {
      activities: globalThis.Array.isArray(object?.activities)
        ? object.activities.map((e: any) => ScvAutonomyActivityConfiguration.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScvAutonomyActivitiesConfiguration): unknown {
    const obj: any = {};
    if (message.activities?.length) {
      obj.activities = message.activities.map((e) => ScvAutonomyActivityConfiguration.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvAutonomyActivitiesConfiguration>, I>>(
    base?: I,
  ): ScvAutonomyActivitiesConfiguration {
    return ScvAutonomyActivitiesConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvAutonomyActivitiesConfiguration>, I>>(
    object: I,
  ): ScvAutonomyActivitiesConfiguration {
    const message = createBaseScvAutonomyActivitiesConfiguration();
    message.activities = object.activities?.map((e) => ScvAutonomyActivityConfiguration.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScvAutonomyActivityConfiguration(): ScvAutonomyActivityConfiguration {
  return {
    activityType: 0,
    heightControl: undefined,
    aux1Control: undefined,
    aux2Control: undefined,
    frontThreePtControl: undefined,
    rearThreePtControl: undefined,
    minTransitionVelocityMps: 0,
    maxTransitionWaitS: 0,
  };
}

export const ScvAutonomyActivityConfiguration: MessageFns<ScvAutonomyActivityConfiguration> = {
  encode(message: ScvAutonomyActivityConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.activityType !== 0) {
      writer.uint32(8).int32(message.activityType);
    }
    if (message.heightControl !== undefined) {
      ScvAutonomyHeightControlConfiguration.encode(message.heightControl, writer.uint32(18).fork()).join();
    }
    if (message.aux1Control !== undefined) {
      ScvAutonomyAuxControlConfiguration.encode(message.aux1Control, writer.uint32(26).fork()).join();
    }
    if (message.aux2Control !== undefined) {
      ScvAutonomyAuxControlConfiguration.encode(message.aux2Control, writer.uint32(34).fork()).join();
    }
    if (message.frontThreePtControl !== undefined) {
      ThreePointAutonomyControlConfiguration.encode(message.frontThreePtControl, writer.uint32(58).fork()).join();
    }
    if (message.rearThreePtControl !== undefined) {
      ThreePointAutonomyControlConfiguration.encode(message.rearThreePtControl, writer.uint32(66).fork()).join();
    }
    if (message.minTransitionVelocityMps !== 0) {
      writer.uint32(45).float(message.minTransitionVelocityMps);
    }
    if (message.maxTransitionWaitS !== 0) {
      writer.uint32(53).float(message.maxTransitionWaitS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvAutonomyActivityConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvAutonomyActivityConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.activityType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.heightControl = ScvAutonomyHeightControlConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.aux1Control = ScvAutonomyAuxControlConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.aux2Control = ScvAutonomyAuxControlConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.frontThreePtControl = ThreePointAutonomyControlConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.rearThreePtControl = ThreePointAutonomyControlConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.minTransitionVelocityMps = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.maxTransitionWaitS = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvAutonomyActivityConfiguration {
    return {
      activityType: isSet(object.activityType)
        ? autonomousActivityTypeFromJSON(object.activityType)
        : isSet(object.activity_type)
        ? autonomousActivityTypeFromJSON(object.activity_type)
        : 0,
      heightControl: isSet(object.heightControl)
        ? ScvAutonomyHeightControlConfiguration.fromJSON(object.heightControl)
        : isSet(object.height_control)
        ? ScvAutonomyHeightControlConfiguration.fromJSON(object.height_control)
        : undefined,
      aux1Control: isSet(object.aux1Control)
        ? ScvAutonomyAuxControlConfiguration.fromJSON(object.aux1Control)
        : isSet(object.aux1_control)
        ? ScvAutonomyAuxControlConfiguration.fromJSON(object.aux1_control)
        : undefined,
      aux2Control: isSet(object.aux2Control)
        ? ScvAutonomyAuxControlConfiguration.fromJSON(object.aux2Control)
        : isSet(object.aux2_control)
        ? ScvAutonomyAuxControlConfiguration.fromJSON(object.aux2_control)
        : undefined,
      frontThreePtControl: isSet(object.frontThreePtControl)
        ? ThreePointAutonomyControlConfiguration.fromJSON(object.frontThreePtControl)
        : isSet(object.front_three_pt_control)
        ? ThreePointAutonomyControlConfiguration.fromJSON(object.front_three_pt_control)
        : undefined,
      rearThreePtControl: isSet(object.rearThreePtControl)
        ? ThreePointAutonomyControlConfiguration.fromJSON(object.rearThreePtControl)
        : isSet(object.rear_three_pt_control)
        ? ThreePointAutonomyControlConfiguration.fromJSON(object.rear_three_pt_control)
        : undefined,
      minTransitionVelocityMps: isSet(object.minTransitionVelocityMps)
        ? globalThis.Number(object.minTransitionVelocityMps)
        : isSet(object.min_transition_velocity_mps)
        ? globalThis.Number(object.min_transition_velocity_mps)
        : 0,
      maxTransitionWaitS: isSet(object.maxTransitionWaitS)
        ? globalThis.Number(object.maxTransitionWaitS)
        : isSet(object.max_transition_wait_s)
        ? globalThis.Number(object.max_transition_wait_s)
        : 0,
    };
  },

  toJSON(message: ScvAutonomyActivityConfiguration): unknown {
    const obj: any = {};
    if (message.activityType !== 0) {
      obj.activityType = autonomousActivityTypeToJSON(message.activityType);
    }
    if (message.heightControl !== undefined) {
      obj.heightControl = ScvAutonomyHeightControlConfiguration.toJSON(message.heightControl);
    }
    if (message.aux1Control !== undefined) {
      obj.aux1Control = ScvAutonomyAuxControlConfiguration.toJSON(message.aux1Control);
    }
    if (message.aux2Control !== undefined) {
      obj.aux2Control = ScvAutonomyAuxControlConfiguration.toJSON(message.aux2Control);
    }
    if (message.frontThreePtControl !== undefined) {
      obj.frontThreePtControl = ThreePointAutonomyControlConfiguration.toJSON(message.frontThreePtControl);
    }
    if (message.rearThreePtControl !== undefined) {
      obj.rearThreePtControl = ThreePointAutonomyControlConfiguration.toJSON(message.rearThreePtControl);
    }
    if (message.minTransitionVelocityMps !== 0) {
      obj.minTransitionVelocityMps = message.minTransitionVelocityMps;
    }
    if (message.maxTransitionWaitS !== 0) {
      obj.maxTransitionWaitS = message.maxTransitionWaitS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvAutonomyActivityConfiguration>, I>>(
    base?: I,
  ): ScvAutonomyActivityConfiguration {
    return ScvAutonomyActivityConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvAutonomyActivityConfiguration>, I>>(
    object: I,
  ): ScvAutonomyActivityConfiguration {
    const message = createBaseScvAutonomyActivityConfiguration();
    message.activityType = object.activityType ?? 0;
    message.heightControl = (object.heightControl !== undefined && object.heightControl !== null)
      ? ScvAutonomyHeightControlConfiguration.fromPartial(object.heightControl)
      : undefined;
    message.aux1Control = (object.aux1Control !== undefined && object.aux1Control !== null)
      ? ScvAutonomyAuxControlConfiguration.fromPartial(object.aux1Control)
      : undefined;
    message.aux2Control = (object.aux2Control !== undefined && object.aux2Control !== null)
      ? ScvAutonomyAuxControlConfiguration.fromPartial(object.aux2Control)
      : undefined;
    message.frontThreePtControl = (object.frontThreePtControl !== undefined && object.frontThreePtControl !== null)
      ? ThreePointAutonomyControlConfiguration.fromPartial(object.frontThreePtControl)
      : undefined;
    message.rearThreePtControl = (object.rearThreePtControl !== undefined && object.rearThreePtControl !== null)
      ? ThreePointAutonomyControlConfiguration.fromPartial(object.rearThreePtControl)
      : undefined;
    message.minTransitionVelocityMps = object.minTransitionVelocityMps ?? 0;
    message.maxTransitionWaitS = object.maxTransitionWaitS ?? 0;
    return message;
  },
};

function createBaseScvAutonomyHeightControlConfiguration(): ScvAutonomyHeightControlConfiguration {
  return { holdTargetHeight: undefined, scvOff: undefined, none: undefined };
}

export const ScvAutonomyHeightControlConfiguration: MessageFns<ScvAutonomyHeightControlConfiguration> = {
  encode(message: ScvAutonomyHeightControlConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.holdTargetHeight !== undefined) {
      writer.uint32(13).float(message.holdTargetHeight);
    }
    if (message.scvOff !== undefined) {
      Empty.encode(message.scvOff, writer.uint32(18).fork()).join();
    }
    if (message.none !== undefined) {
      Empty.encode(message.none, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvAutonomyHeightControlConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvAutonomyHeightControlConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.holdTargetHeight = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scvOff = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.none = Empty.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvAutonomyHeightControlConfiguration {
    return {
      holdTargetHeight: isSet(object.holdTargetHeight)
        ? globalThis.Number(object.holdTargetHeight)
        : isSet(object.hold_target_height)
        ? globalThis.Number(object.hold_target_height)
        : undefined,
      scvOff: isSet(object.scvOff)
        ? Empty.fromJSON(object.scvOff)
        : isSet(object.scv_off)
        ? Empty.fromJSON(object.scv_off)
        : undefined,
      none: isSet(object.none) ? Empty.fromJSON(object.none) : undefined,
    };
  },

  toJSON(message: ScvAutonomyHeightControlConfiguration): unknown {
    const obj: any = {};
    if (message.holdTargetHeight !== undefined) {
      obj.holdTargetHeight = message.holdTargetHeight;
    }
    if (message.scvOff !== undefined) {
      obj.scvOff = Empty.toJSON(message.scvOff);
    }
    if (message.none !== undefined) {
      obj.none = Empty.toJSON(message.none);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvAutonomyHeightControlConfiguration>, I>>(
    base?: I,
  ): ScvAutonomyHeightControlConfiguration {
    return ScvAutonomyHeightControlConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvAutonomyHeightControlConfiguration>, I>>(
    object: I,
  ): ScvAutonomyHeightControlConfiguration {
    const message = createBaseScvAutonomyHeightControlConfiguration();
    message.holdTargetHeight = object.holdTargetHeight ?? undefined;
    message.scvOff = (object.scvOff !== undefined && object.scvOff !== null)
      ? Empty.fromPartial(object.scvOff)
      : undefined;
    message.none = (object.none !== undefined && object.none !== null) ? Empty.fromPartial(object.none) : undefined;
    return message;
  },
};

function createBaseScvAutonomyAuxControlConfiguration(): ScvAutonomyAuxControlConfiguration {
  return { entryAction: 0 };
}

export const ScvAutonomyAuxControlConfiguration: MessageFns<ScvAutonomyAuxControlConfiguration> = {
  encode(message: ScvAutonomyAuxControlConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entryAction !== 0) {
      writer.uint32(8).int32(message.entryAction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScvAutonomyAuxControlConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScvAutonomyAuxControlConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.entryAction = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScvAutonomyAuxControlConfiguration {
    return {
      entryAction: isSet(object.entryAction)
        ? scvAutonomyAuxControlActionFromJSON(object.entryAction)
        : isSet(object.entry_action)
        ? scvAutonomyAuxControlActionFromJSON(object.entry_action)
        : 0,
    };
  },

  toJSON(message: ScvAutonomyAuxControlConfiguration): unknown {
    const obj: any = {};
    if (message.entryAction !== 0) {
      obj.entryAction = scvAutonomyAuxControlActionToJSON(message.entryAction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScvAutonomyAuxControlConfiguration>, I>>(
    base?: I,
  ): ScvAutonomyAuxControlConfiguration {
    return ScvAutonomyAuxControlConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScvAutonomyAuxControlConfiguration>, I>>(
    object: I,
  ): ScvAutonomyAuxControlConfiguration {
    const message = createBaseScvAutonomyAuxControlConfiguration();
    message.entryAction = object.entryAction ?? 0;
    return message;
  },
};

function createBaseAutonomyAuthorized(): AutonomyAuthorized {
  return { authorized: false, lockingUserIds: [] };
}

export const AutonomyAuthorized: MessageFns<AutonomyAuthorized> = {
  encode(message: AutonomyAuthorized, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.authorized !== false) {
      writer.uint32(8).bool(message.authorized);
    }
    for (const v of message.lockingUserIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutonomyAuthorized {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutonomyAuthorized();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.authorized = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lockingUserIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AutonomyAuthorized {
    return {
      authorized: isSet(object.authorized) ? globalThis.Boolean(object.authorized) : false,
      lockingUserIds: globalThis.Array.isArray(object?.lockingUserIds)
        ? object.lockingUserIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.locking_user_ids)
        ? object.locking_user_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AutonomyAuthorized): unknown {
    const obj: any = {};
    if (message.authorized !== false) {
      obj.authorized = message.authorized;
    }
    if (message.lockingUserIds?.length) {
      obj.lockingUserIds = message.lockingUserIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AutonomyAuthorized>, I>>(base?: I): AutonomyAuthorized {
    return AutonomyAuthorized.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutonomyAuthorized>, I>>(object: I): AutonomyAuthorized {
    const message = createBaseAutonomyAuthorized();
    message.authorized = object.authorized ?? false;
    message.lockingUserIds = object.lockingUserIds?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
